/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import CountCard from '../Components/count-card/count-card';
import { customShipmentColumns } from './shipmentColumns';
import {
  BoxIcon,
  CalenderIcon,
  ChatIcon,
  CurrencyWalletIcon,
  // EditIcon,
  EditReceiptIcon,
  InfoBlueGradientIcon,
  InfoIcon,
  InfoPinkGredientIcon,
  OpenEyeIcon,
  PinkPinIcon,
  // LocationIcon,
  // SMSIcon,
  // TextEditIcon,
  TimezoneIcon,
  UndoIcon,
} from '../Components/icons/icons';
import ListingStatus from '../Components/listing-status/listing-status';
import ShipmentMode from '../Components/shipment-mode/shipment-mode';
import UserGroup from '../Components/user-group/user-group';
import {
  isNotificationExistForBooking,
  isNotificationExistForOrder,
} from '../helpers/notificationHelper';
import QuantityCard from '../Components/quantity-card/quantity-card';
import PartNumber from '../Components/part-number/part-number';
import DateHistory from '../Components/date-history/date-history';
import DatepickerBox from '../Components/datepicker-box/datepicker-box';
import TimeLog from '../Components/time-log/time-log';
import EditBox from '../Components/edit-box/edit-box';
import Tooltip from '../Components/tooltip/tooltip';
// import TextBox from '../Components/text-box/text-box';
import NumberCard from '../Components/number-card/number-card';
import { DropDownSts } from '../pages/details-page/details-listing/details-listing';
// import Button from '../Components/button/button';
import Dialog from '../Components/dialog/dialog';
import ViewBooking from '../Components/create-booking/view-booking';
import useDialog from '../Components/dialog/useDialog';
import BesicTable from '../Components/table/basicTable';
import AdvancePopover from '../Components/advance-popover/advance-popover';
import BuyerBooking from '../Components/create-booking/buyer';
import SearchSelect from '../Components/search-select/search-select';
import { VIEW_QUOTATION_LIST } from '../graphQL/bookingList';
import UserImage from '../Components/user-image/user-image';
import { getUserTimeZoneDateFormat } from '../helpers/dateHelper';
import IconButton from '../Components/icon-button/icon-button';
import { checkPermission, hasNoOrderPerm } from '../helpers/permissionHelper';
import { giveProfile } from '../Components/global-notification/notification-list';
import getInitials, { isNumber } from '../helpers/utils';
import getRelationalOrgByOrgId from '../helpers/organization.helper';
import UserDetails from '../Components/user-details/user-details';
import CountIcon from '../Components/count-card/count-icon';
import AdvanceSelectLabel from '../Components/advance-select/advance-select-label';
import CustomSwitch from '../Components/custom-switch/custom-switch';
import UserCounter from '../Components/user-counter/user-counter';
// import { CalenderEditIcon } from '../Components/icons/filter-icons';
// import Confirmation from '../Components/confirmation/confirmation';

// import LocationGroup from '../Components/location-group/location-group';
// import UserImage from '../Components/user-image/user-image';
// import {
//   RatingStatus,
//   TotalRating,
// } from '../Components/total-rating/total-rating';
// import getInitials from '../helpers/utils';
const d = new Date();
const year = d.getFullYear();
function dateIsValid(date) {
  return !Number.isNaN(new Date(date).getTime());
}

const falseValue = false;
const getUnit = (pkgUnit) => {
  switch (pkgUnit) {
    case 'metric':
      return 'cm';
    case 'imperial':
      return 'in';
    default:
      return '';
  }
};

export const lineItemColumns = (
  cargoReady,
  bookingType,
  isEmailApproval = false,
  pkgWtUnit
) => [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.itemid')}</>;
    },
    accessor: 'itemCode',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.orderid')}</>;
    },
    accessor: 'order',
    Cell: (data) => {
      const { row } = data;
      const { relation, companyId } = useParams();
      return (
        <>
          {!isEmailApproval &&
          !['forwarder', 'customBroker'].includes(relation) &&
          !hasNoOrderPerm(giveProfile(relation), 'Order') &&
          bookingType !== 'consolidated' ? (
            <Link
              to={`/app/${relation}/${companyId}/order-details/${
                row?.original?.orderId || ''
              }`}
            >
              {row.original.poNumber}
            </Link>
          ) : (
            row.original.poNumber
          )}
          <span />
        </>
      );
    },
  },
  ...(cargoReady
    ? [
        {
          Header: () => {
            const [t] = useTranslation('manageorders');
            return <>{t('manageordersscreen.lineItembtn.cargoready')}</>;
          },
          align: 'center',
          accessor: 'dueDate',
          type: 'date',
          Cell: (data) => {
            const {
              cell: {
                row: {
                  original: { dueDate },
                },
              },
            } = data;
            return getUserTimeZoneDateFormat(dueDate);
          },
        },
      ]
    : []),
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.quantitytoship')}</>;
    },
    accessor: 'qtyShipped',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.dimensions')}</>;
    },
    accessor: 'Dimensions (LXWXH)',
    Cell: (data) => {
      const { row } = data;
      const { dimensions } = row.original;
      const { length, width, height } = dimensions?.[0] || {};
      const units = getUnit(pkgWtUnit);

      return (
        <span className="no-wrap text-center d-block">
          {isNumber(length) && isNumber(width) && isNumber(height)
            ? `${length} X ${width} X ${height}${
                length !== 0 || width !== 0 || height !== 0 ? ` ${units}` : ''
              }`
            : '--'}
        </span>
      );
    },
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.weight')}</>;
    },
    accessor: 'Weight',
    Cell: (data) => {
      const {
        row: {
          original: { grossWeight, grossWeightUnit },
        },
      } = data;
      return (
        <span className="no-wrap">{`${grossWeight} ${grossWeightUnit}`}</span>
      );
    },
  },
];

export const BookListRateQuote = [
  {
    Header: '',
    accessor: 'orgLogo',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <UserImage
          name={row?.original?.forwarderDetail?.orgName}
          path={row?.original?.forwarderDetail?.orgLogo}
          shortName={getInitials(row?.original?.forwarderDetail?.orgName)}
          removeTooltip
        />
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.quotesmenu.forwarder')}</>;
    },
    accessor: 'orgName',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/booking-details/${
            row.original.channelId || ''
          }`}
        >
          {row?.original?.forwarderDetail?.orgName}
        </Link>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.quotesmenu.liner')}</>;
    },
    accessor: 'linearName',
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.quotesmenu.pricequoted')}</>;
    },
    align: 'center',
    accessor: 'totalPrice',
    Cell: (data) => {
      const { row } = data;
      return (
        <>
          {row?.original?.totalPrice && row?.original?.totalPrice !== '--' ? (
            <div className="d-flex align-center">
              <span className="mr-10">
                <CurrencyWalletIcon />
              </span>
              {`${row?.original?.totalPrice} ${
                row?.original?.currency && row?.original?.currency !== '--'
                  ? row?.original?.currency
                  : ''
              }`}
            </div>
          ) : (
            '--'
          )}
          <span />
        </>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.quotesmenu.quotevalidity')}</>;
    },
    align: 'center',
    accessor: 'linerExpiry',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <p>
          {row?.original?.linerExpiry
            ? getUserTimeZoneDateFormat(row?.original?.linerExpiry)
            : '--'}
        </p>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.quotesmenu.quotestatus')}</>;
    },
    align: 'center',
    accessor: 'status',
    Cell: (data) => {
      const { row } = data;
      return (
        <>
          {row.original.status === '--' ? (
            '--'
          ) : (
            <ListingStatus statusLabel={row.original.status} />
          )}
          <span />
        </>
      );
    },
  },
];

export const BookListOrder = [
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.ordersmenu.order')}</>;
    },
    accessor: 'order',
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.ordersmenu.item')}</>;
    },
    accessor: 'orderItem',
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.ordersmenu.cargoready')}</>;
    },
    align: 'center',
    accessor: 'cargoReady',
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.ordersmenu.status')}</>;
    },
    align: 'center',
    accessor: 'orderStatus',
  },
];
export const BookListOrderRfq = [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.productname')}</>;
    },
    accessor: 'packageName',
    Cell: (data) => {
      const { row } = data;
      const { packageName } = row.original;
      return packageName || '--'; // No Fragment needed, return single element directly
    },
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.dimensions')}</>;
    },
    accessor: 'Dimensions (LXWXH)',
    Cell: (data) => {
      const { row } = data;
      const { dimensions, measurementUnit } = row.original;
      const { length, width, height } = dimensions?.[0] || {};
      const units = getUnit(measurementUnit);

      return (
        <span className="no-wrap text-center d-block">
          {isNumber(length) && isNumber(width) && isNumber(height)
            ? `${length} X ${width} X ${height}${
                length !== 0 || width !== 0 || height !== 0 ? ` ${units}` : ''
              }`
            : '--'}
        </span>
      );
    },
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.quantity-key')}</>;
    },
    accessor: 'qtyShipped',
    Cell: (data) => {
      const { row } = data;
      const { qtyShipped } = row.original;
      return isNumber(qtyShipped) ? qtyShipped : '--';
    },
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.lineItembtn.weight')}</>;
    },
    accessor: 'weight',
    Cell: (data) => {
      const { row } = data;
      const { weight, measurementUnit } = row.original;
      return isNumber(weight)
        ? `${weight} ${measurementUnit === 'metric' ? 'kgs' : 'lbs'}`
        : '--';
    },
    align: 'center',
  },
];

export const BookListOrder2 = [
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.ordersmenu.order')}</>;
    },
    accessor: 'order',
    Cell: (data) => {
      const {
        row,
        row: {
          values: { order },
        },
      } = data;
      const { relation, companyId } = useParams();
      return (
        <>
          {!['forwarder', 'customBroker'].includes(relation) &&
          !hasNoOrderPerm(giveProfile(relation), 'Order') ? (
            <Link
              to={`/app/${relation}/${companyId}/order-details/${
                row?.original?.orderId || ''
              }`}
            >
              {order}
            </Link>
          ) : (
            order
          )}
          <span />
        </>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.ordersmenu.item')}</>;
    },
    accessor: 'orderItem',
  },
  {
    Header: () => {
      const [t] = useTranslation('managebooking');
      return <>{t('managebookingscreen.ordersmenu.cargoready')}</>;
    },
    align: 'center',
    accessor: 'cargoReady',
  },
  // {
  //   Header: () => {
  //     const [t] = useTranslation('managebooking');
  //     return <>{t('managebookingscreen.ordersmenu.status')}</>;
  //   },
  //   align: 'center',
  //   accessor: 'orderStatus',
  // },
];
// export const cargoRadyDateColumns = [
//   {
//     Header: 'Order Item#',
//     accessor: 'itemCode',
//   },
//   {
//     Header: 'Quantity',
//     accessor: 'quantity',
//   },
//   {
//     Header: 'Cargo Ready Date',
//     accessor: 'dueDate',
//     Cell: (data) => {
//       const [t] = useTranslation('status');
//       const [date, setDate] = useState(new Date());
//       const [isDateSelected, toggleDateSelected] = useState(false);
//       const [showPendingOrderDate, setShowPendingOrderDate] = useState(false);
//       const [selectedPendingDate, setPendingDate] = useState(new Date());
//       const handleCancelClick = () => {
//         setShowPendingOrderDate(true);
//       };

//       const handleCargoReadySubmit = () => {
//         console.log('Cargo ready date submitted');
//       };

//       const setCargoReadyDate = () => {
//         console.log('Successful');
//       };

//       const {
//         cell: { value },
//         row: {
//           original: { showCalendar },
//         },
//       } = data;

//       const [eventValue, setEventValue] = useState(null);

//       const togglePopover = (e) => {
//         setEventValue(e.target);
//       };

//       const handleClose = () => {
//         setEventValue(null);
//       };
//       return (
//         <div className="d-flex align-items-center justify-evenly">
//           <span>{value}</span>
//           {showCalendar && (
//             <>
//               {/* <div className="datepickers">
//                 <div className="datepicker-header">
//                   <label>{t('statuslist.cargoradydate.selectcargodate')}</label>
//                 </div>

//                 <div className="datepicker-container">
//                   <DatepickerBox
//                     inline
//                     onChange={(e) => {
//                       if (e <= new Date()) {
//                         setDate(e);
//                       }
//                     }}
//                   />
//                 </div>
//                 <div className="datepicker-footer d-flex">
//                   <button type="button" className="button cancel">
//                     {t('statuslist.cargoradydate.cancel')}
//                   </button>
//                   <button
//                     type="submit"
//                     className="button action primary"
//                     onClick={toggleDateSelected}
//                   >
//                     {date
//                       ? `${t(
//                           'statuslist.cargoradydate.select'
//                         )} ${date.toLocaleDateString()}`
//                       : t('statuslist.cargoradydate.selectdate')}
//                   </button>
//                 </div>
//               </div> */}

//               <button
//                 type="button"
//                 id="showDateBox"
//                 onClick={togglePopover}
//                 className="icon-button w-auto"
//               >
//                 <CalenderEditIcon color="#0088FA" />
//               </button>
//               <AdvancePopover
//                 reference="showDateBox"
//                 closePopover={handleClose}
//                 getEvent={eventValue}
//                 placement="left"
//                 zIndex={10000002}
//               >
//                 <div className="datepicker-header">
//                   <label>{t('statuslist.cargoradydate.selectcargodate')}</label>
//                 </div>
//                 <div className="cargo-datepickers">
//                   <div className="datepicker-container">
//                     <DatepickerBox
//                       inline
//                       onChange={(e) => {
//                         if (e <= new Date()) {
//                           setDate(e);
//                         }
//                       }}
//                       // dateFormat="yyyy/MM/dd"
//                     />
//                   </div>
//                   <div className="datepicker-footer border-top d-flex ">
//                     <button type="button" className="button cancel">
//                       {t('statuslist.cargoradydate.cancel')}
//                     </button>
//                     <button
//                       type="submit"
//                       className="button action primary"
//                       onClick={toggleDateSelected}
//                     >
//                       {date
//                         ? `${t(
//                             'statuslist.cargoradydate.select'
//                           )} ${date.toLocaleDateString()}`
//                         : t('statuslist.cargoradydate.selectdate')}
//                     </button>
//                   </div>
//                 </div>
//               </AdvancePopover>

//               <Dialog
//                 isShowing={isDateSelected}
//                 hide={toggleDateSelected}
//                 placement="center"
//                 maskZindex={10000004}
//               >
//                 {!showPendingOrderDate ? (
//                   <Confirmation
//                     cancelButtonText={t('statuslist.cargoradydate.no')}
//                     submitButtonText={t('statuslist.cargoradydate.yes')}
//                     title={t('statuslist.cargoradydate.cargoreadydate')}
//                     description={t('statuslist.cargoradydate.confirmationmsg')}
//                     onSubmitClick={setCargoReadyDate}
//                     onCancelClick={handleCancelClick}
//                   />
//                 ) : (
//                   <div className="d-flex align-center">
//                     <Confirmation
//                       cancelButtonText={t(
//                         'statuslist.cargoradydate.enterlater'
//                       )}
//                       submitButtonText={t('statuslist.cargoradydate.enter')}
//                       title={t('statuslist.cargoradydate.cargoreadydate')}
//                       description={t(
//                         'statuslist.cargoradydate.pendingconfirmation'
//                       )}
//                       onSubmitClick={handleCargoReadySubmit}
//                       onCancelClick={() => setShowPendingOrderDate(false)}
//                       btnColor="enter-later"
//                     >
//                       <DatepickerBox
//                         onChange={(e) => {
//                           if (e <= new Date()) {
//                             setPendingDate(e);
//                           }
//                         }}
//                         selectedDate={selectedPendingDate}
//                         mTop="1.389vw"
//                         enableEdit
//                       />
//                     </Confirmation>
//                   </div>
//                 )}
//               </Dialog>
//             </>
//           )}
//         </div>
//       );
//     },
//   },
// ];

// const cargoData = [
//   {
//     itemCode: 'Split 1 C823451',
//     quantity: 5000,
//     dueDate: '15/05/2023',
//     showCalendar: <DatepickerBox enableEdit />,
//   },
//   {
//     itemCode: 'Split 2 C823451',
//     quantity: 5000,
//     dueDate: '20/05/2023',
//     showCalendar: <DatepickerBox enableEdit />,
//   },
// ];

export const orderItemColumns = [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.orderitem')}</>;
    },
    accessor: 'itemCode',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.productname')}</>;
    },
    accessor: 'itemName',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <p className="max-w-100 text-limit">{row.original.itemName}</p>;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.quantity')}</>;
    },
    accessor: 'quantity',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const [t] = useTranslation('manageorders');
      return (
        <div className="d-flex justify-center">
          <NumberCard
            value={row.original.quantity}
            status="primary"
            content={t('manageordersscreen.order.tooltip.total')}
          />
          <NumberCard
            value={row.original.cargoQty}
            status="success"
            content={t('manageordersscreen.order.tooltip.processed')}
          />
          <NumberCard
            value={row.original.bookedQty}
            status="warning"
            content={t('manageordersscreen.order.tooltip.booked')}
          />
          <NumberCard
            value={row.original.pendingQty || 0}
            content={t('manageordersscreen.order.tooltip.pending')}
          />
          <NumberCard
            value={row.original.scheduledQty || 0}
            content={t('manageordersscreen.order.tooltip.remaining')}
            // size="small"
            status="remaining"
          />
        </div>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.totalprice')}</>;
    },
    accessor: 'total',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.escargoready')}</>;
    },
    accessor: 'dueDate',
    enableSortBy: true,
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.dueDate
            ? getUserTimeZoneDateFormat(row?.original?.dueDate)
            : '--'}
        </span>
      );
    },
    // Cell: (data) => {
    //   const {
    //     cell: { value, row },
    //   } = data;

    //   const isCargoReady = row.original.statusName === 'Cargo Ready';
    //   const [eventValue, setEventValue] = useState(null);

    //   const togglePopover = (e) => {
    //     setEventValue(e.target);
    //   };

    //   const handleClose = () => {
    //     setEventValue(null);
    //   };

    //   return (
    //     <div className="d-flex align-items-center justify-center">
    //       <button
    //         className="cargo-ready-datebtn"
    //         type="button"
    //         onClick={togglePopover}
    //         id="cargodatePopover"
    //       >
    //         <span>{value}</span>
    //         <span className="iconSpan" style={{ marginLeft: '0.556vw' }}>
    //           {isCargoReady && <CalenderEditIcon color="#0088FA" />}
    //         </span>
    //       </button>
    //       <AdvancePopover
    //         reference="cargodatePopover"
    //         getEvent={eventValue}
    //         closePopover={handleClose}
    //         placement="left"
    //       >
    //         <div className="count-card-table">
    //           <BesicTable columns={cargoRadyDateColumns} data={cargoData} />
    //         </div>
    //       </AdvancePopover>
    //     </div>
    //   );
    // },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.deliverydate')}</>;
    },
    accessor: 'deliveryDate',
    enableSortBy: true,
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.deliveryDate
            ? getUserTimeZoneDateFormat(row?.original?.deliveryDate)
            : '--'}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.status')}</>;
    },
    accessor: 'statusName',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const { relation } = useParams();
      return (
        <DropDownSts
          lineItem={row?.original}
          statusLabel={row.original.statusName}
          enableDropdown={
            !(row.original.parent && !row.original.parentId) &&
            row?.original?.eventAction?.upComingStage?.length > 0 &&
            ((giveProfile(relation) === 'supplier' &&
              checkPermission(
                giveProfile(relation),
                'Order',
                'Milestone update'
              )) ||
              (giveProfile(relation) === 'buyer' &&
                checkPermission(
                  giveProfile(relation),
                  'Supplier Role',
                  'Milestone update'
                )))
          }
          futureStatus={row?.original?.eventAction?.upComingStage}
        />
      );
    },
  },
  {
    Header: <TimezoneIcon width="1.25vw" height="1.25vw" />,
    accessor: 'newlineItemWiseProposeChange',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <TimeLog data={row.original.newlineItemWiseProposeChange} />;
    },
  },
];

// new columns for Vitro
export const orderItemColumns2 = [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.itemsequenceId')}</>;
    },
    accessor: 'itemSequenceId',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span className="d-flex align-center">
          {row?.original?.itemName && (
            <span className="enable-pointer">
              <Tooltip content={row?.original?.itemName} direction="top">
                <InfoPinkGredientIcon />
              </Tooltip>
            </span>
          )}
          <span className="pl-3">
            {row?.original?.itemSequenceId
              ? row?.original?.itemSequenceId
              : '--'}
          </span>
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.orderitemVitro')}</>;
    },
    accessor: 'itemCode',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.materialGroup')}</>;
    },
    accessor: 'materialGroup',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.materialGroup ? row?.original?.materialGroup : '--'}
        </span>
      );
    },
  },
  // {
  //   Header: () => {
  //     const [t] = useTranslation('manageorders');
  //     return <>{t('manageordersscreen.order.productname')}</>;
  //   },
  //   accessor: 'itemName',
  // },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.quantity')}</>;
    },
    accessor: 'quantity',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const [t] = useTranslation('manageorders');
      return (
        <div className="d-flex justify-center">
          <NumberCard
            value={row.original.quantity}
            status="primary"
            content={t('manageordersscreen.order.tooltip.total')}
            size="small"
          />
          <NumberCard
            value={row.original.cargoQty}
            status="success"
            content={t('manageordersscreen.order.tooltip.processed')}
            size="small"
          />
          <NumberCard
            value={row.original.bookedQty}
            status="warning"
            content={t('manageordersscreen.order.tooltip.booked')}
            size="small"
          />
          <NumberCard
            value={row.original.pendingQty || 0}
            content={t('manageordersscreen.order.tooltip.pending')}
            size="small"
          />
          {/* @Apurba UI fix needed here */}
          <NumberCard
            value={row.original.scheduledQty || 0}
            content={t('manageordersscreen.order.tooltip.remaining')}
            size="small"
            status="remaining"
          />
        </div>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.orderUnit')}</>;
    },
    accessor: 'orderUnit',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.orderUnit ? row?.original?.orderUnit : '--'}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.totalprice')}</>;
    },
    accessor: 'total',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.total}{' '}
          {row?.original?.currency ? row?.original?.currency : ''}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.escargoready')}</>;
    },
    accessor: 'dueDate',
    enableSortBy: true,
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.dueDate
            ? getUserTimeZoneDateFormat(row?.original?.dueDate)
            : '--'}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.deliverydate')}</>;
    },
    accessor: 'deliveryDate',
    enableSortBy: true,
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.deliveryDate
            ? getUserTimeZoneDateFormat(row?.original?.deliveryDate)
            : '--'}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.status')}</>;
    },
    accessor: 'statusName',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const { relation } = useParams();
      return (
        <DropDownSts
          lineItem={row?.original}
          statusLabel={row.original.statusName}
          enableDropdown={
            !(row.original.parent && !row.original.parentId) &&
            row?.original?.eventAction?.upComingStage?.length > 0 &&
            ((giveProfile(relation) === 'supplier' &&
              checkPermission(
                giveProfile(relation),
                'Order',
                'Milestone update'
              )) ||
              (giveProfile(relation) === 'buyer' &&
                checkPermission(
                  giveProfile(relation),
                  'Supplier Role',
                  'Milestone update'
                )))
          }
          futureStatus={row?.original?.eventAction?.upComingStage}
        />
      );
    },
  },
  {
    Header: <TimezoneIcon width="1.25vw" height="1.25vw" />,
    accessor: 'newlineItemWiseProposeChange',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <TimeLog data={row.original.newlineItemWiseProposeChange} />;
    },
  },
];

export const orderItemScheduled = [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.orderitem')}</>;
    },
    accessor: 'itemCode',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.productname')}</>;
    },
    accessor: 'itemName',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <p className="max-w-160 text-limit">{row.original.itemName}</p>;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.quantity')}</>;
    },
    accessor: 'quantity',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const [t] = useTranslation('manageorders');
      return (
        <div className="d-flex justify-center">
          <NumberCard
            value={row.original.quantity}
            status="primary"
            content={t('manageordersscreen.order.tooltip.total')}
          />
          <NumberCard
            value={row.original.cargoQty}
            status="success"
            content={t('manageordersscreen.order.tooltip.processed')}
          />
          <NumberCard
            value={row.original.bookedQty}
            status="warning"
            content={t('manageordersscreen.order.tooltip.booked')}
          />
          <NumberCard
            value={row.original.pendingQty || 0}
            content={t('manageordersscreen.order.tooltip.pending')}
          />
        </div>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.totalprice')}</>;
    },
    accessor: 'total',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.escargoready')}</>;
    },
    accessor: 'dueDate',
    enableSortBy: true,
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <>{getUserTimeZoneDateFormat(row?.original?.dueDate)}</>;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.deliverydate')}</>;
    },
    accessor: 'deliveryDate',
    enableSortBy: true,
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <>{getUserTimeZoneDateFormat(row?.original?.deliveryDate)}</>;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.status')}</>;
    },
    accessor: 'statusName',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const { relation } = useParams();
      return (
        <DropDownSts
          lineItem={row?.original}
          statusLabel={row.original.statusName}
          enableDropdown={
            !(row.original.parent && !row.original.parentId) &&
            row?.original?.eventAction?.upComingStage?.length > 0 &&
            ((giveProfile(relation) === 'supplier' &&
              checkPermission(
                giveProfile(relation),
                'Order',
                'Milestone update'
              )) ||
              (giveProfile(relation) === 'buyer' &&
                checkPermission(
                  giveProfile(relation),
                  'Supplier Role',
                  'Milestone update'
                )))
          }
          futureStatus={row?.original?.eventAction?.upComingStage}
        />
      );
    },
  },

  {
    Header: <TimezoneIcon width="1.25vw" height="1.25vw" />,
    accessor: 'newlineItemWiseProposeChange',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <TimeLog data={row.original.newlineItemWiseProposeChange} />;
    },
  },
];

export const priceMiniTable = () => {
  const [t] = useTranslation('manageorders');
  return [
    {
      Header: t('manageordersscreen.order.pricePerUnit'),
      align: 'center',
      accessor: (row) => {
        return (
          <span className="pl-3">
            {isNumber(row?.pricePerUnit)
              ? `${row?.pricePerUnit} ${row?.currency || ''}`
              : '--'}
          </span>
        );
      },
    },
    {
      Header: t('manageordersscreen.order.netPrice'),
      align: 'center',
      accessor: (row) => {
        return (
          <span className="pl-3">
            {isNumber(row?.netPrice)
              ? `${row?.netPrice} ${row?.currency || ''}`
              : '--'}
          </span>
        );
      },
    },
  ];
};

// new columns for Vitro
export const orderItemScheduled2 = [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.itemsequenceId')}</>;
    },
    accessor: 'itemSequenceId',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span className="d-flex align-center">
          {row?.original?.itemName && (
            <span className="enable-pointer">
              <Tooltip content={row?.original?.itemName} direction="top">
                <InfoPinkGredientIcon />
              </Tooltip>
            </span>
          )}
          <span className="pl-3">
            {row?.original?.itemSequenceId
              ? row?.original?.itemSequenceId
              : '--'}
          </span>
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.orderitemVitro')}</>;
    },
    accessor: 'itemCode',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.materialGroup')}</>;
    },
    accessor: 'materialGroup',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.materialGroup ? row?.original?.materialGroup : '--'}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.quantity')}</>;
    },
    accessor: 'quantity',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const [t] = useTranslation('manageorders');
      return (
        <div className="d-flex justify-center">
          <NumberCard
            value={row.original.quantity}
            status="primary"
            content={t('manageordersscreen.order.tooltip.total')}
            size="small"
          />
          <NumberCard
            value={row.original.cargoQty}
            status="success"
            content={t('manageordersscreen.order.tooltip.processed')}
            size="small"
          />
          <NumberCard
            value={row.original.bookedQty}
            status="warning"
            content={t('manageordersscreen.order.tooltip.booked')}
            size="small"
          />
          <NumberCard
            value={row.original.pendingQty || 0}
            content={t('manageordersscreen.order.tooltip.pending')}
            size="small"
          />
        </div>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.orderUnit')}</>;
    },
    accessor: 'orderUnit',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.orderUnit ? row?.original?.orderUnit : '--'}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.totalprice')}</>;
    },
    accessor: 'total',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span className="d-flex align-center">
          <span className="pl-3">
            {row?.original?.total}{' '}
            {row?.original?.currency ? row?.original?.currency : ''}
          </span>
          <CountIcon
            label={<InfoBlueGradientIcon size="0.694vw" />}
            disableBorder
            disableHover
            columns={priceMiniTable()}
            data={[
              {
                netPrice: row?.original?.netPrice,
                pricePerUnit: row?.original?.pricePerUnit,
                currency: row?.original?.currency,
              },
            ]}
            align="center"
            popoverPlacement="left"
            enableDynamicTable={true}
            disableBorderOnHover
          />
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.escargoready')}</>;
    },
    accessor: 'dueDate',
    enableSortBy: true,
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <>{getUserTimeZoneDateFormat(row?.original?.dueDate)}</>;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.deliverydate')}</>;
    },
    accessor: 'deliveryDate',
    enableSortBy: true,
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span>
          {row?.original?.deliveryDate
            ? getUserTimeZoneDateFormat(row?.original?.deliveryDate)
            : '--'}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.order.status')}</>;
    },
    accessor: 'statusName',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      const { relation } = useParams();
      return (
        <DropDownSts
          lineItem={row?.original}
          statusLabel={row.original.statusName}
          enableDropdown={
            !(row.original.parent && !row.original.parentId) &&
            row?.original?.eventAction?.upComingStage?.length > 0 &&
            ((giveProfile(relation) === 'supplier' &&
              checkPermission(
                giveProfile(relation),
                'Order',
                'Milestone update'
              )) ||
              (giveProfile(relation) === 'buyer' &&
                checkPermission(
                  giveProfile(relation),
                  'Supplier Role',
                  'Milestone update'
                )))
          }
          futureStatus={row?.original?.eventAction?.upComingStage}
        />
      );
    },
  },

  {
    Header: <TimezoneIcon width="1.25vw" height="1.25vw" />,
    accessor: 'newlineItemWiseProposeChange',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <TimeLog data={row.original.newlineItemWiseProposeChange} />;
    },
  },
];

export const itemizedOrderItemColumns = [
  {
    Header: 'Order Item#',
    accessor: 'itemCode',
  },
  {
    Header: 'Product Name',
    accessor: 'itemName',
  },
  {
    Header: 'Impex PO#',
    accessor: 'po_number',
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    CellL: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <QuantityCard
          quantityObj={row.original.quantityObj ? row.original.quantityObj : []}
        />
      );
    },
  },
  {
    Header: 'Status',
    accessor: 'statusName',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <ListingStatus statusLabel={row.original.statusName} />;
    },
  },
  ...(falseValue
    ? [
        {
          Header: <TimezoneIcon width="1.25vw" height="1.25vw" />,
          accessor: 'timeline',
          Cell: (data) => {
            const {
              cell: { row },
            } = data;
            return <TimeLog data={row.original.timeline} />;
          },
        },
      ]
    : []),
];

export const ShipmentorderItemColumns = [
  {
    Header: 'Order Item#',
    accessor: 'itemCode',
  },
  {
    Header: 'Product Name',
    accessor: 'itemName',
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },

  {
    Header: 'Delivery Date',
    accessor: 'dueDate',
  },
  // {
  //   Header: 'Status',
  //   accessor: 'statusName',
  //   Cell: (data) => {
  //     const {
  //       cell: { row },
  //     } = data;
  //     return <ListingStatus statusLabel={row.original.statusName} />;
  //   },
  // },
];

const buyerBookingNewColumns = (showLineItems = true) => {
  const columnData = [
    {
      Header: 'Package type',
      accessor: 'packageName',
    },
    {
      Header: 'Quantity',
      accessor: 'quantity',
      Cell: (data) => {
        const {
          row: {
            values: { quantity },
          },
        } = data;

        return (
          <div className="d-flex">
            <NumberCard value={quantity} status="primary" />
            {/* <NumberCard value={quantity} status="success" />
            <NumberCard value={quantity} status="warning" />
            <NumberCard value={quantity} /> */}
          </div>
        );
      },
    },
    {
      Header: 'Dimensions (LXWXH)',
      accessor: 'dimensionsFormatted',
      Cell: () => {},
    },

    {
      Header: 'Gross Weight',
      accessor: 'grossWeight',
    },
    ...(showLineItems
      ? [
          {
            Header: 'Line Items',
            accessor: '',
            align: 'center',
            Cell: () => (
              <AdvanceSelectLabel
                placeholder="Select Line Items"
                className="select-item"
              />
            ),
          },
        ]
      : []),
  ];
  return columnData;
};

export { buyerBookingNewColumns };

const buyerBookingDetailsColumns = (
  cargoReady,
  isRFQ,
  bookingDetailsPage,
  bookingType,
  isEmailApproval = false
) => {
  const columnsData = [
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.bookingdetailsbtn.packagetype')}</>;
      },
      accessor: 'packageType',
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return bookingDetailsPage
          ? t('manageordersscreen.bookingdetailsbtn.packageQuantity')
          : t('manageordersscreen.bookingdetailsbtn.quantity');
      },
      accessor: 'pkgQty',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        const [t] = useTranslation('manageorders');
        return (
          <div className="d-flex justify-center">
            {row.original.isVendorPackage ? (
              'NA'
            ) : (
              <NumberCard
                value={row?.original?.pkgQty}
                status="primary"
                // {bookingDetailsPage ? 'primary' : 'purple'}
                content={t('manageordersscreen.bookingdetailsbtn.tooltip')}
              />
            )}
          </div>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.bookingdetailsbtn.dimensions')}</>;
      },
      accessor: 'Dimensions (LXWXH)',
      align: 'center',
      Cell: (data) => {
        const {
          row: { original },
        } = data;
        const length = isNumber(original?.dimentions?.length)
          ? original?.dimentions?.length
          : original?.dimensions?.length;
        const width = isNumber(original?.dimentions?.width)
          ? original?.dimentions?.width
          : original?.dimensions?.width;
        const height = isNumber(original?.dimentions?.height)
          ? original?.dimentions?.height
          : original?.dimensions?.height;

        const units = getUnit(original?.pkgWtUnit);

        return (
          <span className="no-wrap text-center d-block">
            {(() => {
              const isDefaultPackage =
                original?.packageType === 'Default Package' ||
                (length === 0 && width === 0 && height === 0);

              if (original?.isVendorPackage || isDefaultPackage) {
                return 'NA';
              }

              if (isNumber(length) && isNumber(width) && isNumber(height)) {
                return `${length} X ${width} X ${height} ${units}`;
              }

              return '--';
            })()}
          </span>
        );
      },
    },

    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.bookingdetailsbtn.grossweight')}</>;
      },
      accessor: 'Gross Weight',
      align: 'center',
      Cell: (data) => {
        const {
          row: {
            original: { pkgGrossWt, pkgWtUnit, isVendorPackage },
          },
        } = data;
        if ((pkgGrossWt == null || pkgWtUnit == null) && !isVendorPackage) {
          return <span className="no-wrap">--</span>;
        }
        const unitLabel = pkgWtUnit === 'imperial' ? 'Lbs' : 'Kgs';
        return (
          <span className="no-wrap">
            {isVendorPackage ? 'NA' : `${pkgGrossWt} ${unitLabel}`}
          </span>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.bookingdetailsbtn.lineitems')}</>;
      },
      accessor: 'Line Items',
      align: 'center',
      Cell: (data) => {
        const [eventValue, setEventValue] = useState();
        const togglePopover = (e) => {
          setEventValue(e.target);
        };
        const handleClose = () => {
          setEventValue(null);
        };
        const {
          cell: {
            row: {
              original: { lineItems, poNumber, pkgWtUnit },
            },
          },
        } = data;
        const [t] = useTranslation('manageorders');
        return (
          <>
            <button
              className="item-selected-button"
              type="button"
              onClick={togglePopover}
              id="countPopover"
            >
              {lineItems?.length}{' '}
              {lineItems?.length > 1
                ? t('manageordersscreen.lineItembtn.itemsbtn')
                : t('manageordersscreen.lineItembtn.itembtn')}
            </button>
            <AdvancePopover
              reference="countPopover"
              getEvent={eventValue}
              closePopover={handleClose}
              placement="left"
            >
              <div className="count-card-table">
                <BesicTable
                  columns={
                    isRFQ
                      ? BookListOrderRfq
                      : lineItemColumns(
                          cargoReady,
                          bookingType,
                          isEmailApproval,
                          pkgWtUnit
                        )
                  }
                  data={lineItems?.map((item) => ({
                    ...item,
                    poNumber: item?.poNumber || poNumber,
                    packageName: item?.itemName,
                    weight: item?.grossWeight,
                  }))}
                  className="auto-column-width"
                />
              </div>
            </AdvancePopover>
          </>
        );
      },
    },
  ];
  return columnsData;
};

export { buyerBookingDetailsColumns };

export const bookingColumns = (refetchOrderDetails) => [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.Bookings.booking')}</>;
    },
    accessor: 'referenceId',
    Cell: (data) => {
      const {
        row: {
          values: { referenceId },
        },
      } = data;
      // const { relation, companyId } = useParams();
      return (
        // <Link
        //   to={`/app/${relation}/${companyId}/booking-details/${
        //     row.original._id || ''
        //   }`}
        // >
        <p>{referenceId}</p>
        // {bookingNo}
        // </Link>
      );
    },
  },

  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.Bookings.mode')}</>;
    },
    accessor: 'mode',
    Cell: (data) => {
      const { row } = data;
      return (
        <ShipmentMode
          shipmentMode={row.original.mode}
          bookingType={row.original.bookingType}
        />
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.Bookings.bookingdate')}</>;
    },
    accessor: 'bookingDate',
    Cell: (data) => {
      const { row } = data;
      return <p>{getUserTimeZoneDateFormat(row?.original?.bookingDate)}</p>;
    },
  },

  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.Bookings.orgin')}</>;
    },
    accessor: 'originFacility',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span className="d-block max-w-200 text-break-word">
          {row.original.originFacility}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.Bookings.destination')}</>;
    },
    accessor: 'destinationFacility',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <span className="d-block max-w-200 text-break-word">
          {row.original.destinationFacility}
        </span>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.Bookings.status')}</>;
    },
    accessor: 'currentStatus',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <ListingStatus statusLabel={row.original.currentStatus} />;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.Bookings.actions')}</>;
    },
    accessor: 'actions',
    Cell: (data) => {
      const {
        isShowing: isViewBookingDetailsDislog,
        toggle: toggleViewDetailsModal,
      } = useDialog();
      const {
        cell: { row },
      } = data;
      const { relation } = useParams();
      const [searchParams, setSearchParams] = useSearchParams();
      const location = useLocation();
      const popover = searchParams.get('popover');
      const popId = searchParams.get('popId');

      useEffect(() => {
        const checkURLParamsAndOpenDialog = () => {
          if (
            popover === 'Create Booking' &&
            !isViewBookingDetailsDislog &&
            popId === row?.original?._id
          ) {
            // popover=Create+Booking&popId=170922967377830106
            toggleViewDetailsModal();
          } else if (
            popover !== 'Create Booking' &&
            isViewBookingDetailsDislog
          ) {
            toggleViewDetailsModal();
          }
        };
        checkURLParamsAndOpenDialog();

        // To resolve flickering issue on refresh, add timeout to skip extra toggling
        // but this doesn't solve the issue entirely, especially for slow networks
        // const timeout = setTimeout(() => {
        //   checkURLParamsAndOpenDialog();
        // }, 300);
        // return () => clearTimeout(timeout);
      }, [location.search]);

      return (
        <div>
          {row?.original?.bookingAction?.addForwarder &&
          checkPermission(giveProfile(relation), 'Booking', 'createBooking') ? (
            <>
              <IconButton
                onClick={() => {
                  // toggleViewDetailsModal();
                  if (
                    searchParams.get('popover') !== 'Create Booking' &&
                    !location.search?.includes('Create+Booking')
                  ) {
                    searchParams.set('popover', 'Create Booking');
                    setSearchParams(searchParams);
                  }
                  if (
                    searchParams.get('popId') !== row?.original?._id &&
                    !location.search?.includes('popId')
                  ) {
                    searchParams.set('popId', row?.original?._id);
                    setSearchParams(searchParams);
                  }
                }}
                verient="success"
              >
                <BoxIcon size="1.25vw" />
              </IconButton>
              <Dialog
                isShowing={isViewBookingDetailsDislog}
                hide={() => {
                  toggleViewDetailsModal();
                  searchParams.delete('popover');
                  searchParams.delete('popId');
                  setSearchParams(searchParams);
                }}
                placement="center"
                // enableOutsideClick
                enableCloseIcon
              >
                <BuyerBooking
                  columns={buyerBookingDetailsColumns()}
                  itemsData={row?.original}
                  toggleViewDetailsModal={toggleViewDetailsModal}
                  refetchOrderDetails={refetchOrderDetails}
                />
              </Dialog>
            </>
          ) : (
            <>
              <IconButton
                onClick={() => {
                  // toggleViewDetailsModal();
                  if (
                    searchParams.get('popover') !== 'Create Booking' &&
                    !location.search?.includes('Create+Booking')
                  ) {
                    searchParams.set('popover', 'Create Booking');
                    setSearchParams(searchParams);
                  }
                  if (
                    searchParams.get('popId') !== row?.original?._id &&
                    !location.search?.includes('popId')
                  ) {
                    searchParams.set('popId', row?.original?._id);
                    setSearchParams(searchParams);
                  }
                }}
                verient="warning"
              >
                <OpenEyeIcon />
              </IconButton>

              <Dialog
                isShowing={isViewBookingDetailsDislog}
                hide={() => {
                  toggleViewDetailsModal();
                  searchParams.delete('popover');
                  searchParams.delete('popId');
                  setSearchParams(searchParams);
                }}
                placement="center"
                // enableOutsideClick
                enableCloseIcon
              >
                <ViewBooking
                  id={row?.original?._id}
                  columns={buyerBookingDetailsColumns()}
                  itemsData={row?.original?.packages}
                  commentData={row?.original?.attachmentComment}
                />
              </Dialog>
            </>
          )}
        </div>
      );
    },
  },
];

export const orderOverviewDetails = [
  {
    title: 'Order#',
    accessor: 'poNumber',
    type: 'string',
  },
  {
    title: 'Created Date',
    accessor: 'createdAt',
    type: 'date',
  },
  {
    title: 'Status',
    accessor: 'currentStatus',
    type: 'string',
  },
  {
    title: 'Last Update',
    accessor: 'LastUpdatedAt',
    type: 'date',
  },
  {
    title: 'Cargo Ready',
    accessor: 'poDueDate',
    type: 'date',
    // Cell: (data) => {
    //   console.log(data, 'Data');
    //   const { row } = data;
    //   return <>{getUserTimeZoneDateFormat(row?.original?.poDueDate)}</>;
    // },
  },
  {
    title: 'Cargo Type',
    accessor: 'cargoType',
    type: 'string',
  },
  {
    title: 'Scheduled Pick-up Date',
    accessor: 'scheduledPickupDate',
    type: 'date',
  },
  // {
  //   title: 'ETA',
  //   accessor: 'ETA',
  //   type: 'date',
  // },
  // {
  //   title: 'New ETA',
  //   accessor: 'newETA',
  //   type: 'date',
  // },
  // {
  //   title: 'Planned ETA',
  //   accessor: 'plannedETA',
  //   type: 'date',
  // },
  {
    title: 'Origin',
    accessor: 'originFacility',
    type: 'string',
  },
  {
    title: 'Destination',
    accessor: 'destinationFacility',
    type: 'string',
  },
];

export const bookingMetaData = [
  {
    title: 'Booking #',
    accessor: 'referenceId',
  },
  {
    title: 'Booking Date',
    accessor: 'bookingDate',
  },
  {
    title: 'Current Status',
    accessor: 'currentStatus',
  },
  {
    title: 'Mode',
    accessor: 'translatedMode',
  },
  {
    title: 'Booking Type',
    accessor: 'translatedBookingType',
  },
  {
    title: 'Incoterm',
    accessor: 'incoTerm',
  },
  {
    title: 'Type of Move',
    accessor: 'typeofMove',
  },
  {
    title: 'Origin',
    accessor: 'originFacility',
  },
  {
    title: 'Destination',
    accessor: 'destinationFacility',
  },
  { title: 'Cargo Type', accessor: 'cargoType' },
  {
    title: 'Scheduled Pick-up Date From',
    accessor: 'scheduledPickupDate',
    type: 'string',
  },
  {
    title: 'Schedule Pick-Up Date To',
    accessor: 'scheduledPickupToDate',
    type: 'string',
  },
  {
    title: 'Container Type',
    accessor: 'containerType',
    isHide: true,
    hideMode: ['Air', 'Inland'],
  },
  {
    title: 'Equipment Type',
    accessor: 'equipmentType',
    isHide: true,
    hideMode: ['Air', 'Inland'],
  },
  {
    title: 'Cargo Load',
    accessor: 'cargoLoad',
    isHide: true,
    hideMode: ['Air', 'Ocean'],
  },
  {
    title: 'Number of Trucks',
    accessor: 'numberOfTrucks',
    isHide: true,
    hideMode: ['Air', 'Ocean'],
  },
  {
    title: 'Shipment #',
    accessor: 'shipmentNo',
    redirectId: 'shipmentId',
    redirectPage: 'shipment-details',
    haltRedirection: () => {
      const { relation } = useParams();
      return hasNoOrderPerm(giveProfile(relation), 'Shipment');
    },
  },
  {
    title: 'Order#',
    accessor: 'poNumber',
    redirectId: 'orderID',
    redirectPage: 'order-details',
    haltRedirection: () => {
      const { relation } = useParams();
      return hasNoOrderPerm(giveProfile(relation), 'Order');
    },
  },
  {
    title: 'Kind Of Goods',
    accessor: 'kindOfGoods',
  },
  {
    title: 'Customs',
    accessor: 'Customs',
  },
  {
    title: 'Has-Mat',
    accessor: 'Has-Mat',
  },

  {
    title: 'Quotation Required By',
    accessor: 'quotationExpiryDate',
  },
  {
    title: 'Cargo Ready Date (ETA)',
    accessor: 'cargoReadyDate',
  },
  {
    title: 'Payment Method',
    accessor: 'paymentMethod',
  },
];

export const bookingItemColumns = [
  {
    Header: 'Item#',
    accessor: 'itemName',
  },
  {
    Header: 'Item Code',
    accessor: 'itemCode',
  },
  // {
  //   Header: 'Price',
  //   accessor: 'price',
  // },
  {
    Header: 'Qty.',
    accessor: 'quantity',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <div className="d-flex justify-center">
          <NumberCard
            value={row?.original?.quantity}
            status="primary"
            content="Quantity"
          />
        </div>
      );
    },
  },
  {
    Header: 'Weight',
    accessor: 'grossWeight',
  },
  {
    Header: 'Line Items',
    accessor: '',
    align: 'center',
    Cell: (data) => {
      const [eventValue, setEventValue] = useState();
      const togglePopover = (e) => {
        setEventValue(e.target);
      };
      const handleClose = () => {
        setEventValue(null);
      };
      const {
        cell: {
          row: {
            original: { lineItems },
          },
        },
      } = data;
      const [t] = useTranslation('manageorders');
      return (
        <>
          <button
            className="item-selected-button"
            type="button"
            onClick={togglePopover}
            id="countPopover"
          >
            {lineItems?.length} {t('manageordersscreen.lineItembtn.itembtn')}
          </button>
          <AdvancePopover
            reference="countPopover"
            getEvent={eventValue}
            closePopover={handleClose}
            placement="left"
          >
            <BesicTable
              columns={lineItemColumns()}
              data={lineItems}
              className="auto-column-width"
            />
          </AdvancePopover>
        </>
      );
    },
  },
];

export const bookingListColumns = (isconsignee) =>
  [
    {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.participants')}</>;
      },
      accessor: 'participants',
      Cell: (data) => {
        const {
          row: { original },
        } = data;
        return (
          <div className="table-col-row">
            <UserGroup
              userData={original?.uniqueUserIds || []}
              moreItemsDetails={{
                id: original?.BookingId,
                module: 'booking',
                count: original?.uniqueUserCount,
                calledAt: 'PO',
              }}
            />
          </div>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.booking')}</>;
      },
      accessor: 'referenceId',
      Cell: (data) => {
        const {
          row,
          row: {
            values: { referenceId },
          },
        } = data;
        const { relation, companyId } = useParams();
        return row?.original?.rateQuote === '--' || relation === 'forwarder' ? (
          <Link
            to={`/app/${relation}/${companyId}/booking-details/${
              row.original._id || ''
            }`}
          >
            {referenceId}
          </Link>
        ) : (
          referenceId
        );
      },
    },
    !isconsignee && {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.order')}</>;
      },
      accessor: 'poNumber',
      Cell: (data) => {
        const {
          row: {
            original: { packages, poNumber, orderID, isRFQ, bookingType },
          },
        } = data;
        // const { relation } = useParams();
        let totalOrders = [];
        const lineItemsData = [];
        packages?.forEach((pkg) =>
          pkg?.lineItems?.forEach((item) => {
            lineItemsData?.push({
              orderId: item?.poID || item?.orderId || orderID,
              order: item?.poNumber || poNumber,
              orderItem: item?.itemCode,
              qtyShipped: item?.qtyShipped,
              orderStatus: item?.statusName,
              cargoReady: getUserTimeZoneDateFormat(item?.dueDate),
              dimensions: item?.dimensions,
              packageName: item?.itemName,
              weight: item?.grossWeight,
              measurementUnit: item?.measurementUnit,
            });
            totalOrders.push(item?.poNumber || poNumber);
          })
        );
        totalOrders = [...new Set(totalOrders)];
        // const [quoteList, setQuoteList] = useState([]);
        // const [handleQuotations] = useLazyQuery(VIEW_QUOTATION_LIST);

        // const handleQuotes = (ip) => {
        //   handleQuotations({
        //     variables: {
        //       input: {
        //         referenceId: ip?.referenceId,
        //         poNumber: ip?.poNumber,
        //         bookingType: ip?.bookingType,
        //       },
        //     },
        //     onCompleted: (resp) => {
        //       setQuoteList(resp?.ViewQuotations?.data);
        //     },
        //   });
        // };
        const [t] = useTranslation('managebooking');
        return bookingType !== 'consolidated' ? (
          <CountCard
            data={lineItemsData}
            label={
              totalOrders?.length === 1
                ? `${totalOrders?.length} ${t(
                    'managebookingscreen.quotesmenu.orderSingular'
                  )}`
                : `${totalOrders?.length || 0} ${t(
                    'managebookingscreen.quotesmenu.orderPlural'
                  )}`
            }
            enableDynamicTable={true}
            columns={isRFQ ? BookListOrderRfq : BookListOrder2}
            disableBorder
          />
        ) : (
          '--'
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.bookingdate')}</>;
      },
      accessor: 'bookingDate',
      // enableSortBy: true,
      setWidth: '6.944vw',
    },
    {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.quotes')}</>;
      },
      accessor: 'rate_quotes',
      Cell: (data) => {
        const {
          cell: { row },
        } = data;
        const { relation } = useParams();
        const [quoteList, setQuoteList] = useState([]);
        const [handleQuotations] = useLazyQuery(VIEW_QUOTATION_LIST);
        const handleQuotes = (ip) => {
          handleQuotations({
            variables: {
              input: {
                referenceId: ip?.referenceId,
                poNumber: ip?.poNumber,
                bookingType: ip?.bookingType,
                profileType: giveProfile(relation),
              },
            },
            onCompleted: (resp) => {
              setQuoteList(resp?.ViewQuotations?.data);
            },
          });
        };
        const [t] = useTranslation('managebooking');
        return row?.original?.rateQoute !== '--' ? (
          <CountCard
            onClick={() => handleQuotes(row?.original)}
            data={quoteList}
            label={
              row?.original?.rateQoute === 1
                ? `${row?.original?.rateQoute} ${t(
                    'managebookingscreen.quotesmenu.titleSingular'
                  )}`
                : `${row?.original?.rateQoute} ${t(
                    'managebookingscreen.quotesmenu.titlePlural'
                  )}`
            }
            enableDynamicTable
            columns={BookListRateQuote}
          />
        ) : (
          <p>{row?.original?.rateQoute}</p>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.mode')}</>;
      },
      accessor: 'mode',
      Cell: (data) => {
        const { row } = data;
        return (
          <ShipmentMode
            shipmentMode={row.original.mode}
            bookingType={row.original.bookingType}
          />
        );
      },
    },
    // {
    //   Header: 'Shipper',
    //   accessor: 'ShipperName',
    // },
    {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.origin')}</>;
      },
      accessor: 'originFacility',
      setWidth: '8.333vw',
    },
    {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.destination')}</>;
      },
      accessor: 'destinationFacility',
      setWidth: '8.333vw',
    },
    // {
    //   Header: 'Consignee',
    //   accessor: 'ConsigneeName',
    // },
    {
      Header: () => {
        const [t] = useTranslation('managebooking');
        return <>{t('managebookingscreen.bookingcardrow.status')}</>;
      },
      accessor: 'currentStatus',
      align: 'center',
      setWidth: '5.556vw',
      Cell: (data) => {
        const {
          row: {
            values: { currentStatus },
          },
        } = data;
        return <ListingStatus statusLabel={currentStatus} />;
      },
    },
    ...(false
      ? [
          {
            Header: () => {
              const [t] = useTranslation('managebooking');
              return (
                <>{t('managebookingscreen.bookingcardrow.notification')}</>
              );
            },
            accessor: 'notification',
            setWidth: '$px100',
            Cell: (data) => {
              const { row } = data;
              const { relation, companyId } = useParams();
              return (
                <Link
                  to={`/app/${relation}/${companyId}/booking-details/${
                    row.original.BookingId || ''
                  }`}
                >
                  <button type="button" className="list-chat-icon">
                    {isNotificationExistForBooking(row.original.BookingId) ===
                      true && <span className="count">&nbsp;</span>}
                    <span className="number">
                      <ChatIcon color="#1D3E69" />
                    </span>
                  </button>
                </Link>
              );
            },
          },
        ]
      : []),
  ].filter(Boolean);

export const ItemizedBookingListColumns = [
  {
    Header: 'Participants',
    accessor: 'participants',
    Cell: (data) => {
      const {
        row: { original },
      } = data;
      return (
        <div className="table-col-row">
          <UserGroup userData={original?.uniqueUserIds || []} />
        </div>
      );
    },
  },
  {
    Header: 'Booking #',
    accessor: 'bookingNo',
    Cell: (data) => {
      const {
        row,
        row: {
          values: { bookingNo },
        },
      } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/booking-details/${
            row.original.BookingId || ''
          }`}
        >
          {bookingNo}
        </Link>
      );
    },
  },
  {
    Header: 'Mode',
    accessor: 'mode',
    Cell: (data) => {
      const {
        row: {
          values: { mode },
        },
      } = data;
      return <ShipmentMode shipmentMode={mode} />;
    },
  },
  {
    Header: 'POL',
    accessor: 'originFacility',
  },
  {
    Header: 'POD',
    accessor: 'pdestinationFacilityod',
  },

  // {
  //   Header: 'Shipper',
  //   accessor: 'ShipperName',
  // },
  {
    Header: 'Ship to unit',
    accessor: 'shipToUnit',
  },
  {
    Header: 'Status',
    accessor: 'currentStatus',
    Cell: (data) => {
      const {
        row: {
          values: { currentStatus },
        },
      } = data;
      return <ListingStatus statusLabel={currentStatus} />;
    },
  },
  {
    Header: 'Notification',
    accessor: 'notification',
    Cell: (data) => {
      const { row } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/booking-details/${
            row.original.BookingId || ''
          }`}
        >
          <button type="button" className="list-chat-icon">
            {isNotificationExistForBooking(row.original.BookingId) === true && (
              <span className="count">&nbsp;</span>
            )}
            <span className="number">
              <ChatIcon color="#1D3E69" />
            </span>
          </button>
        </Link>
      );
    },
  },
];
export const orderListColumnsOmniConnect = [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.participants');
    },
    accessor: 'username',
    align: 'center',

    Cell: (data) => {
      const {
        row: { original },
      } = data;
      return (
        <div className="table-col-row justify-center">
          <UserGroup
            userData={original?.uniqueUserIds || []}
            moreItemsDetails={{
              id: original?.poId,
              module: 'order',
              count: original?.uniqueUserCount,
              calledAt: 'PO',
            }}
          />
        </div>
      );
    },
  },
  {
    Header: '',
    accessor: 'isBlanket',
    align: 'center',
    className: 'px-0',

    Cell: (data) => {
      const {
        row: { original },
      } = data;

      return original.isBlanket && <PinkPinIcon />;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.order');
    },
    accessor: 'poNumber',
    align: 'left',
    className: 'pl-0',

    Cell: (data) => {
      const {
        row,
        row: {
          values: { poNumber },
        },
      } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/order-details/${
            row.original.poId || ''
          }`}
          className="link"
        >
          {poNumber}
        </Link>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.ordercardrow.jdpo')}</>;
    },
    accessor: 'jdPO',
    align: 'center',
    className: 'pl-0',
    Cell: (data) => {
      const {
        row: { original },
      } = data;
      return <div style={{ textAlign: 'center' }}>{original?.ERPPOId}</div>;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.totalitems');
    },
    accessor: 'lineItems',
    align: 'center',

    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <CountCard
          data={row.original.lineItems}
          label={row?.original?.lineItems?.length}
          align="center"
        />
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.createddate');
    },
    accessor: 'createdAt',
    enableSortBy: true,
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.duedate');
    },
    accessor: 'poDueDate',
    enableSortBy: true,
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.updateddate');
    },
    accessor: 'LastUpdatedAt',
    enableSortBy: true,
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.status');
    },
    enableSortBy: false,
    accessor: 'currentStatus',
    align: 'center',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <ListingStatus
          statusLabel={row.original.currentStatus || ''}
          className="max-w-125"
        />
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.notification');
    },
    accessor: 'notification',
    align: 'center',

    Cell: (data) => {
      const { row } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/order-details/${
            row.original.poId || ''
          }`}
          className="list-chat-icon"
        >
          {isNotificationExistForOrder(row.original.poId) === true && (
            <span className="count">&nbsp;</span>
          )}
          <span className="number">
            <ChatIcon color="#1D3E69" />
          </span>
        </Link>
      );
    },
  },
];
export const orderListColumns = [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.participants');
    },
    accessor: 'username',
    align: 'center',

    Cell: (data) => {
      const {
        row: { original },
      } = data;
      return (
        <div className="table-col-row justify-center">
          <UserGroup
            userData={original?.uniqueUserIds || []}
            moreItemsDetails={{
              id: original?.poId,
              module: 'order',
              count: original?.uniqueUserCount,
              calledAt: 'PO',
            }}
          />
        </div>
      );
    },
  },
  {
    Header: '',
    accessor: 'isBlanket',
    align: 'center',
    className: 'px-0',

    Cell: (data) => {
      const {
        row: { original },
      } = data;

      return original.isBlanket && <PinkPinIcon />;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.order');
    },
    accessor: 'poNumber',
    align: 'left',
    className: 'pl-0',

    Cell: (data) => {
      const {
        row,
        row: {
          values: { poNumber },
        },
      } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/order-details/${
            row.original.poId || ''
          }`}
          className="link"
        >
          {poNumber}
        </Link>
      );
    },
  },
  // {
  //   Header: 'Total Qty',
  //   accessor: 'totalQty',
  //   Cell: (data) => {
  //     const {
  //       row: {
  //         values: { totalQty },
  //       },
  //     } = data;
  //     return <div style={{ textAlign: 'center' }}>{totalQty}</div>;
  //   },
  // },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.totalitems');
    },
    accessor: 'lineItems',
    align: 'center',

    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <CountCard
          data={row.original.lineItems}
          label={row?.original?.lineItems?.length}
          align="center"
        />
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.createddate');
    },
    accessor: 'createdAt',
    enableSortBy: true,
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.deliverydate');
    },
    accessor: 'poDueDate',
    enableSortBy: true,
    align: 'center',
    // Cell: (data) => {
    //   const { row } = data;
    //   return <>{getUserTimeZoneDateFormat(row?.original?.poDueDate)}</>;
    // },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.updatedon');
    },
    accessor: 'LastUpdatedAt',
    enableSortBy: true,
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.status');
    },
    accessor: 'currentStatus',
    align: 'center',
    enableSortBy: false,
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <ListingStatus
          statusLabel={row.original.currentStatus || ''}
          className="max-w-125"
        />
      );
    },
  },
  ...(false
    ? [
        {
          Header: () => {
            const [t] = useTranslation('manageorders');
            return t('manageordersscreen.ordercardrow.notification');
          },
          accessor: 'notification',
          align: 'center',

          Cell: (data) => {
            const { row } = data;
            const { relation, companyId } = useParams();
            return (
              <Link
                to={`/app/${relation}/${companyId}/order-details/${
                  row.original.poId || ''
                }`}
                className="list-chat-icon"
              >
                {isNotificationExistForOrder(row.original.poId) === true && (
                  <span className="count">&nbsp;</span>
                )}
                <span className="number">
                  <ChatIcon color="#1D3E69" />
                </span>
              </Link>
            );
          },
        },
      ]
    : []),
];

export const myOrderListColumns = [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.participants');
    },
    accessor: 'participants',
    Cell: (data) => {
      const {
        row: { original },
      } = data;
      return (
        <div className="table-col-row">
          <UserGroup
            userData={original?.uniqueUserIds || []}
            moreItemsDetails={{
              id: original?.poId,
              module: 'order',
              count: original?.uniqueUserCount,
              calledAt: 'PO',
            }}
          />
        </div>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.suppliers');
    },
    accessor: 'username',
    Cell: (data) => {
      const {
        row: { original },
      } = data;
      const { relation } = useParams();
      const orgKey = `${relation}Id`;
      const orgData = getRelationalOrgByOrgId(original[orgKey]);
      return (
        <div className="table-col-row">
          <UserDetails
            profilePic={orgData?.orgLogo}
            userName={orgData?.orgName}
          />
        </div>
      );
    },
  },
  {
    Header: '',
    accessor: 'isBlanket',
    align: 'center',
    className: 'px-0',
    Cell: (data) => {
      const {
        row: { original },
      } = data;

      return original.isBlanket && <PinkPinIcon />;
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.ordercardrow.order')}</>;
    },
    accessor: 'poNumber',
    align: 'left',
    className: 'pl-0',

    Cell: (data) => {
      const {
        row,
        row: {
          values: { poNumber },
        },
      } = data;
      const { relation } = useParams();
      const orgKey = `${relation}Id`;
      const orgData = getRelationalOrgByOrgId(row?.original[orgKey]);
      return (
        <Link
          to={`/app/${relation}/${orgData?._id}/order-details/${
            row.original.poId || ''
          }`}
          className="link"
        >
          {poNumber}
        </Link>
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.ordercardrow.totalitems')}</>;
    },
    accessor: 'lineItems',
    align: 'center',

    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <CountCard
          data={row.original.lineItems}
          label={row?.original?.lineItems?.length}
          align="center"
        />
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.ordercardrow.createddate')}</>;
    },
    accessor: 'createdAt',
    enableSortBy: true,
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t('manageordersscreen.ordercardrow.deliverydate');
    },
    accessor: 'poDueDate',
    enableSortBy: true,
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.ordercardrow.updatedon')}</>;
    },
    accessor: 'LastUpdatedAt',
    enableSortBy: true,
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.ordercardrow.status')}</>;
    },
    accessor: 'currentStatus',
    align: 'center',
    enableSortBy: false,
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <ListingStatus
          statusLabel={row.original.currentStatus || ''}
          className="max-w-125"
        />
      );
    },
  },
];

export const itemizedOrderListColumns = [
  {
    Header: 'Participants',
    accessor: 'username',
    Cell: (data) => {
      const {
        row: { original },
      } = data;
      return (
        <div className="table-col-row">
          <UserGroup userData={original?.uniqueUserIds || []} />
        </div>
      );
    },
  },
  {
    Header: 'JD Order #',
    accessor: 'poNumber',
    Cell: (data) => {
      const {
        row,
        row: {
          values: { poNumber },
        },
      } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/order-details/${
            row.original.poId || ''
          }`}
        >
          {poNumber}
        </Link>
      );
    },
  },
  {
    Header: 'Parts',
    accessor: 'parts',
    Cell: (data) => {
      const {
        row: {
          values: { parts },
        },
      } = data;
      return <div style={{ textAlign: 'center' }}>{parts}</div>;
    },
  },
  {
    Header: 'Shipping Unit',
    accessor: 'shippingUnit',
  },
  {
    Header: 'Delivery Date',
    accessor: 'poDueDate',
    // Cell: (data) => {
    //   const { row } = data;
    //   return <>{getUserTimeZoneDateFormat(row?.original?.poDueDate)}</>;
    // },
  },
  {
    Header: 'Quantity',
    accessor: 'lineItems',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <QuantityCard
          quantityObj={row.original.quantityObj ? row.original.quantityObj : []}
        />
      );
    },
  },

  {
    Header: 'Status',
    accessor: 'currentStatus',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <ListingStatus statusLabel={row.original.currentStatus || ''} />;
    },
  },
  // {
  //   Header: 'Mode',
  //   accessor: 'mode',
  //   Cell: () => {
  //     return (
  //       <ShipmentMode
  //         multipleMode
  //         startShipment="10000"
  //         endShipment="10000"
  //         startShipmentMode="Ocean"
  //         endShipmentMode="Air"
  //       />
  //     );
  //   },
  // },
  {
    Header: 'Notification',
    accessor: 'notification',
    Cell: (data) => {
      const { row } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/order-details/${
            row.original.poId || ''
          }`}
          className="list-chat-icon"
        >
          {isNotificationExistForOrder(row.original.poId) === true && (
            <span className="count">&nbsp;</span>
          )}
          <span className="number">
            <ChatIcon color="#1D3E69" />
          </span>
        </Link>
      );
    },
  },
];

export const itemizedOrderListReadyToBookColumns = [
  {
    Header: 'Participants',
    accessor: 'username',
    Cell: (data) => {
      const {
        row: { original },
      } = data;
      return (
        <div className="table-col-row">
          <UserGroup userData={original?.uniqueUserIds || []} />
        </div>
      );
    },
  },
  {
    Header: 'JD Order #',
    accessor: 'poNumber',
    Cell: (data) => {
      const {
        row,
        row: {
          values: { poNumber },
        },
      } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/order-details/${
            row.original.poId || ''
          }`}
        >
          {poNumber}
        </Link>
      );
    },
  },
  {
    Header: 'Parts',
    accessor: 'parts',
    Cell: () => {
      // const {
      //   cell: { row },
      // } = data;
      return (
        <PartNumber
          // text={row.original.parts}
          text="1234"
        />
      );
    },
  },
  {
    Header: 'Unit Name',
    accessor: 'shipping_unit',
  },
  {
    Header: `Delivery Dates ${year}`,
    accessor: 'deliveryDates',
    Cell: () => {
      // const {
      //   cell: { row },
      // } = data;
      return <DateHistory />;
    },
  },
  {
    Header: 'Quantity',
    accessor: 'lineItems',
    Cell: () => {
      // const {
      //   cell: { row },
      // } = data;
      return (
        <QuantityCard total="1000" placed="1000" warehouse="0" rejected="" />
      );
    },
  },

  {
    Header: 'Status',
    accessor: 'currentStatus',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <ListingStatus statusLabel={row.original.currentStatus || ''} />;
    },
  },
  {
    Header: 'Notification',
    accessor: 'notification',
    Cell: (data) => {
      const { row } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/order-details/${
            row.original.poId || ''
          }`}
          className="list-chat-icon"
        >
          {isNotificationExistForOrder(row.original.poId) === true && (
            <span className="count">&nbsp;</span>
          )}
          <span className="number">
            <ChatIcon color="#1D3E69" />
          </span>
        </Link>
      );
    },
  },
];

export const shipmentOrderPageColumns = (fetchCustomDetails) => {
  const columnsData = [
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.shipments.shipment')}</>;
      },
      accessor: 'shipmentNo',
      Cell: (data) => {
        const {
          row,
          row: {
            values: { shipmentNo },
            original: { bookingType },
          },
        } = data;
        const { relation, companyId } = useParams();
        return bookingType !== 'consolidated' || relation === 'forwarder' ? (
          <Link
            to={`/app/${relation}/${companyId}/shipment-details/${row.original._id}`}
          >
            {shipmentNo}
          </Link>
        ) : (
          <Link to={`/app/${relation}/shipment-details/${row.original._id}`}>
            {shipmentNo}
          </Link>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.shipments.BLHBL')}</>;
      },
      accessor: 'BLno',
      align: 'center',
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.shipments.mode')}</>;
      },
      accessor: 'mode',
      Cell: (data) => {
        const {
          row: {
            original: { bookingType },
            values: { mode },
          },
        } = data;
        return <ShipmentMode shipmentMode={mode} bookingType={bookingType} />;
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageshipments');
        return <>{t('manageshipmentsscreen.shipmentscardrow.customs')}</>;
      },
      accessor: 'customs',
      align: 'center',
      Cell: ({ row }) => {
        const {
          _id: shipmentId,
          currentCustomStatus,
          CustomCount,
        } = row.original;
        const { relation } = useParams();
        const [t] = useTranslation('status');
        const [customsByShipmentId, setCustomsByShipmentId] = useState({});
        const [isCustomStatusLoading, setIsCustomStatusLoading] =
          useState(false);
        const normalizeCustomStatus = (raw) => {
          if (!raw || raw === '--' || raw === '') return 'Not Started';
          if (['Acknowledged', 'Customs Started'].includes(raw))
            return 'In Progress';
          return raw;
        };
        const rawLabel =
          currentCustomStatus && currentCustomStatus !== '--'
            ? currentCustomStatus
            : customsByShipmentId?.[shipmentId]?.[0]?.status || 'Not Started';
        const label = normalizeCustomStatus(rawLabel);
        const handleClick = async () => {
          if (!shipmentId || customsByShipmentId[shipmentId]) return;
          try {
            setIsCustomStatusLoading(true);
            const { data } = await fetchCustomDetails({
              variables: {
                input: {
                  profileType: giveProfile(relation),
                  shipmentId,
                },
              },
            });
            const detail = data?.FetchCustomDetail?.data || [];
            if (!detail) return;
            setCustomsByShipmentId((prev) => ({
              ...prev,
              [shipmentId]: detail,
            }));
          } catch (err) {
            console.error(err);
          } finally {
            setIsCustomStatusLoading(false);
          }
        };
        return (
          <CountCard
            data={customsByShipmentId?.[shipmentId] ?? []}
            columns={customShipmentColumns}
            enableDynamicTable={true}
            onClick={handleClick}
            align="center"
            popoverPlacement="right-center"
            tableClass="w-760-px"
            disableBorder
            labelClass="d-flex align-center"
            isLoading={isCustomStatusLoading}
            disableClick={!CustomCount}
          >
            <span className="max-w-80 d-block text-wrap">
              {t(`statuslist.status.${label}`)}
            </span>
            {CustomCount > 0 && (
              <span className="ml-5">
                <UserCounter text={CustomCount} size="xxx-small" />
              </span>
            )}
          </CountCard>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageshipments');
        return <>{t('manageshipmentsscreen.shipmentscardrow.status')}</>;
      },
      accessor: 'currentStatus',
      align: 'center',
      Cell: (data) => {
        const {
          row: {
            values: { currentStatus },
          },
        } = data;
        return <ListingStatus statusLabel={currentStatus} />;
      },
    },
    // {
    //   Header: 'Action',
    //   accessor: '',
    //   Cell: () => {
    //     return (
    //       <div className="action small">
    //         <Tooltip content="Accept" direction="bottom">
    //           <button type="button" className="accept">
    //             <AcceptBorderedIcon color="#666666" size="20" />
    //           </button>
    //         </Tooltip>

    //         <Tooltip content="Reject" direction="bottom">
    //           <button type="button" className="reject">
    //             <RejectBorderedIcon color="#666666" />
    //           </button>
    //         </Tooltip>
    //       </div>
    //     );
    //   },
    // },
  ];
  return columnsData;
};

export const shipmentRoutingColumns = [
  {
    Header: 'POL',
    accessor: 'pol',
  },
  {
    Header: 'POD',
    accessor: 'pod',
  },
  {
    Header: 'IMO#',
    accessor: 'imoNumber',
  },
  {
    Header: 'Vessel Name',
    accessor: 'vesselname',
  },
  {
    Header: 'Voyage',
    accessor: 'voyage',
  },
  {
    Header: 'Carrier',
    accessor: 'carrier',
  },
  {
    Header: 'ETA',
    accessor: 'eta',
  },
  {
    Header: 'CarrierCode',
    accessor: 'carrierCode',
  },
  {
    Header: 'Flight No',
    accessor: 'flightNo',
  },
];

export const shipmentContainerColumns = [
  {
    Header: 'Container #',
    accessor: 'description',
  },
];

const orderItemProposeChangeColumns = (setNewValue, setIsError) => {
  const columnData = [
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.proposechanges.orderitem')}</>;
      },
      accessor: 'itemCode',
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.proposechanges.productname')}</>;
      },
      accessor: 'itemName',
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.proposechanges.cargoready')}</>;
      },
      accessor: 'dueDate',
      Cell: (data) => {
        let {
          row: {
            original: { dueDate },
          },
        } = data;
        const {
          row: {
            index,
            original: { errorMessage, ErrorColumn },
          },
        } = data;
        const newDueDate = dueDate.toString().split('/');
        if (newDueDate[1]) {
          dueDate = `${newDueDate[1]}/${newDueDate[0]}/${newDueDate[2]}`;
        }
        return (
          <div
            className={`propose-change-date-picker ${
              ErrorColumn && ErrorColumn.includes('updatedDueDate')
                ? 'error'
                : ''
            }`}
          >
            <DatepickerBox
              selectedDate={dateIsValid(dueDate) && new Date(dueDate)}
              setDate={(e) => {
                setNewValue({
                  values: e,
                  columnName: 'updatedDueDate',
                  index,
                });
              }}
              disableIcon={true}
            />
            {ErrorColumn && ErrorColumn.includes('updatedDueDate') && (
              <Tooltip
                content={`${
                  ErrorColumn &&
                  ErrorColumn.includes('updatedDueDate') &&
                  errorMessage.filter((item) => {
                    if (item.updatedDueDate) {
                      return item.updatedDueDate;
                    }
                    return '';
                  })[0].updatedDueDate
                }`}
                direction="right"
              >
                <InfoIcon width="0.694vw" color="#f00" height="$px10" />
              </Tooltip>
            )}
            <CalenderIcon
              color={
                ErrorColumn && ErrorColumn.includes('updatedDueDate')
                  ? '#f00'
                  : ''
              }
            />
          </div>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.proposechanges.quantity')}</>;
      },
      accessor: 'quantity',
      Cell: (data) => {
        const {
          row: {
            index,
            values: { quantity },
            original: { preQuantity, errorMessage, ErrorColumn },
          },
        } = data;

        return (
          <EditBox
            defaultValue={quantity}
            setNewValue={(e) => {
              const nextVal = Math.trunc(e.target.value);
              setNewValue({
                values: nextVal,
                columnName: 'updatedQuantity',
                index,
              });
              //  }
            }}
            setIsError={setIsError}
            min="1"
            max={preQuantity}
            id="Quantity"
            pattern="[0-9]"
            isError={ErrorColumn && ErrorColumn.includes('updatedQuantity')}
            errorMessage={
              ErrorColumn &&
              ErrorColumn.includes('updatedQuantity') &&
              errorMessage.filter((item) => {
                if (item.updatedQuantity) {
                  return item.updatedQuantity;
                }
                return '';
              })[0].updatedQuantity
            }
          />
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.proposechanges.priceperunit')}</>;
      },
      accessor: 'price',
      Cell: (data) => {
        const {
          row: {
            index,
            original: { price, errorMessage, ErrorColumn },
          },
        } = data;
        return (
          <EditBox
            defaultValue={price}
            setNewValue={(e) => {
              setNewValue({
                values: e.target.value || 0,
                columnName: 'perUnitPrice',
                index,
              });
            }}
            setIsError={setIsError}
            min="1"
            id="PerUnitPrice"
            isError={ErrorColumn && ErrorColumn.includes('perUnitPrice')}
            errorMessage={
              ErrorColumn &&
              ErrorColumn.includes('perUnitPrice') &&
              errorMessage.filter((item) => {
                if (item.perUnitPrice) {
                  return item.perUnitPrice;
                }
                return '';
              })[0].perUnitPrice
            }
          />
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.proposechanges.discount')}</>;
      },
      accessor: 'discountPer',
      Cell: (data) => {
        const {
          row: {
            index,
            values: { discountPer },
            original: { errorMessage, ErrorColumn },
          },
        } = data;
        return (
          <EditBox
            defaultValue={discountPer}
            setNewValue={(e) => {
              setNewValue({
                values: e.target.value || 0,
                columnName: 'updatedDiscount',
                index,
              });
            }}
            setIsError={setIsError}
            min="0"
            id="DiscountPercentage"
            isError={ErrorColumn && ErrorColumn.includes('updatedDiscount')}
            errorMessage={
              ErrorColumn &&
              ErrorColumn.includes('updatedDiscount') &&
              errorMessage.filter((item) => {
                if (item.updatedDiscount) {
                  return item.updatedDiscount;
                }
                return '';
              })[0].updatedDiscount
            }
          />
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.proposechanges.totalprice')}</>;
      },
      accessor: 'total',
      Cell: (data) => {
        const {
          row: {
            index,
            values: { total },
            original: { errorMessage, ErrorColumn },
          },
        } = data;
        return (
          <EditBox
            defaultValue={total}
            setNewValue={(e) => {
              if (e.target.value) {
                setNewValue({
                  values: e.target.value,
                  columnName: 'updatedTotal',
                  index,
                });
              }
            }}
            setIsError={setIsError}
            min="0"
            id="Total"
            isError={ErrorColumn && ErrorColumn.includes('updatedTotal')}
            errorMessage={
              ErrorColumn &&
              ErrorColumn.includes('updatedTotal') &&
              errorMessage.filter((item) => {
                if (item.updatedTotal) {
                  return item.updatedTotal;
                }
                return '';
              })[0].updatedTotal
            }
          />
        );
      },
    },

    {
      Header: '',
      accessor: 'reset',
      Cell: (data) => {
        const {
          row: {
            index,
            original: { _id, isUndo },
          },
        } = data;

        return (
          <IconButton
            className="button-transparent reset"
            onClick={() => {
              setNewValue({
                values: _id,
                columnName: 'reset',
                index,
              });
            }}
            disabled={!isUndo}
          >
            <UndoIcon />
          </IconButton>
        );
      },
    },
  ];
  return columnData;
};
export { orderItemProposeChangeColumns };

export const itemizedOrderSublineItemColumns = [
  {
    Header: 'Order Item#',
    accessor: 'itemCode',
  },
  {
    Header: 'Product Name',
    accessor: 'itemName',
  },
  {
    Header: 'Impex PO#',
    accessor: 'itemNumber',
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <QuantityCard
          quantityObj={row.original.quantityObj ? row.original.quantityObj : []}
        />
      );
    },
  },
  {
    Header: 'Status',
    accessor: 'statusName',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <ListingStatus statusLabel={row.original.statusName} />;
    },
  },
  ...(falseValue
    ? [
        {
          Header: <TimezoneIcon width="1.25vw" height="1.25vw" />,
          accessor: 'timeline',
          Cell: (data) => {
            const {
              cell: { row },
            } = data;
            return <TimeLog data={row.original.timeline} />;
          },
        },
      ]
    : []),
];

export const packageInformationColumn = [
  {
    Header: 'Package type',
    accessor: 'packageType',
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return <NumberCard value={row?.original?.quantity} status="primary" />;
    },
  },
  {
    Header: 'Container#',
    accessor: 'containerNumber',
  },
  {
    Header: 'Dimensions (LXWXH)',
    accessor: 'dimensions',
  },
  {
    Header: 'Gross Weight ',
    accessor: 'grossWeight',
  },
  {
    Header: 'Line Items',
    accessor: '',
    align: 'center',
    Cell: (data) => {
      const [eventValue, setEventValue] = useState();
      const togglePopover = (e) => {
        setEventValue(e.target);
      };
      const handleClose = () => {
        setEventValue(null);
      };
      const {
        cell: {
          row: {
            original: { lineItems },
          },
        },
      } = data;
      const [t] = useTranslation('manageorders');
      return (
        <>
          <button
            className="item-selected-button"
            type="button"
            onClick={togglePopover}
            id="countPopover"
          >
            {lineItems?.length} {t('manageordersscreen.lineItembtn.itembtn')}
          </button>
          <AdvancePopover
            reference="countPopover"
            getEvent={eventValue}
            closePopover={handleClose}
            placement="left"
          >
            <BesicTable
              columns={lineItemColumns()}
              data={lineItems}
              className="auto-column-width"
            />
          </AdvancePopover>
        </>
      );
    },
  },
];

export const supplierBookingNewColumns = ({
  setNewValue,
  packageOptions,
  handleAddPackage,
  selectProduct,
  renderNewColumns,
  vendorPackageButton,
  setApplyAllOption,
  hasPoNumber,
}) => {
  const columnData = [
    ...(renderNewColumns
      ? [
          {
            Header: () => {
              const [t] = useTranslation('manageorders');
              return <>{t('manageordersscreen.order.itemsequenceId')}</>;
            },
            accessor: 'itemSequenceId',
            align: 'center',
            Cell: (data) => {
              const {
                cell: { row },
              } = data;
              return (
                <span>
                  {row?.original?.itemSequenceId
                    ? row?.original?.itemSequenceId
                    : '--'}
                </span>
              );
            },
          },
          {
            Header: () => {
              const [t] = useTranslation('manageorders');
              return <>{t('manageordersscreen.order.orderitemVitro')}</>;
            },
            accessor: 'itemCode',
            align: 'center',
          },
          {
            Header: () => {
              const [t] = useTranslation('manageorders');
              return <>{t('manageordersscreen.order.materialGroup')}</>;
            },
            accessor: 'materialGroup',
            align: 'center',
            Cell: (data) => {
              const {
                cell: { row },
              } = data;
              return (
                <span>
                  {row?.original?.materialGroup
                    ? row?.original?.materialGroup
                    : '--'}
                </span>
              );
            },
          },
        ]
      : [
          ...(hasPoNumber
            ? [
                {
                  Header: () => {
                    const [t] = useTranslation('manageorders');
                    return t('manageordersscreen.ordercardrow.order');
                  },
                  align: 'center',
                  accessor: 'poNumber',
                },
              ]
            : []),
          {
            Header: () => {
              const [t] = useTranslation('manageorders');
              return (
                <span className="no-wrap">
                  {t('manageordersscreen.sendbookingdetails.orderitem')}
                </span>
              );
            },
            align: 'center',
            accessor: 'itemCode',
          },
          {
            Header: () => {
              const [t] = useTranslation('manageorders');
              return (
                <span className="no-wrap">
                  {t('manageordersscreen.sendbookingdetails.productname')}
                </span>
              );
            },
            align: 'center',
            accessor: 'itemName',
          },
        ]),
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return (
          <span className="no-wrap">
            {t('manageordersscreen.sendbookingdetails.quantity')}
          </span>
        );
      },
      align: 'center',
      accessor: 'quantity',
      Cell: (data) => {
        const {
          cell: { row },
        } = data;
        const [t] = useTranslation('manageorders');
        return (
          <div className="d-flex justify-center">
            <NumberCard
              value={row?.original?.quantity}
              status="primary"
              content={t('manageordersscreen.order.tooltip.total')}
            />

            <NumberCard
              value={row?.original?.cargoQty}
              status="success"
              content={t('manageordersscreen.order.tooltip.processed')}
            />
            <NumberCard
              value={row?.original?.bookedQty}
              status="warning"
              content={t('manageordersscreen.order.tooltip.booked')}
            />
            <NumberCard
              value={row?.original?.pendingQty || 0}
              content={t('manageordersscreen.order.tooltip.pending')}
            />
          </div>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return (
          <span className="no-wrap">
            {t('manageordersscreen.sendbookingdetails.dimensions')}
          </span>
        );
      },
      align: 'center',
      accessor: 'dimensions',
      Cell: (data) => {
        const { row } = data;
        return (
          <span className="no-wrap text-center d-block">
            {row?.original?.LXWXH}
          </span>
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return (
          <span className="no-wrap">
            {t('manageordersscreen.sendbookingdetails.cargoready')}
          </span>
        );
      },
      align: 'center',
      accessor: 'cargoReadyDate',
      Cell: ({ row }) => {
        const dateStr = row?.original?.cargoReadyDate;

        if (!dateStr) return '--';

        return <span>{getUserTimeZoneDateFormat(dateStr)}</span>;
      },
    },
    // ...(falseValue
    //   ? [
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return (
          <span className="no-wrap">
            {t('manageordersscreen.sendbookingdetails.quantitytoship')}
          </span>
        );
      },
      align: 'center',
      accessor: 'quantityToShip',
      Cell: (data) => {
        const { row } = data;
        const {
          row: {
            index,
            // original: { errorMessage, ErrorColumn },
          },
        } = data;
        const [t] = useTranslation('manageorders');
        const calculatedQtyToShip = (
          Number(row?.original?.cargoQty) - Number(row?.original?.bookedQty)
        ).toFixed(3);
        return (
          <EditBox
            eanbleTextBox
            className="quantity-box"
            defaultValue={
              row?.original?.quantityToShip || calculatedQtyToShip || ''
            }
            setNewValue={(e) => {
              // if (e.target.value) {
              setNewValue({
                values: e.target.value,
                columnName: 'quantityToShip',
                index,
              });
              // }
            }}
            min="0.001"
            max={calculatedQtyToShip}
            id="quantityToShip"
            errorMessage={`${t(
              'manageordersscreen.sendbookingdetails.addpackagedetailsbtn.errormessage.quantity'
            )} ${calculatedQtyToShip}`}
            errorLogic={calculatedQtyToShip}
            name="quantityToShip"
            decimalLimit={3}
          />
        );
      },
    },
    //   ]
    // : []),
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return (
          <span className="no-wrap">
            {t('manageordersscreen.sendbookingdetails.grossweight')}
          </span>
        );
      },
      align: 'center',
      accessor: 'grossWeight',
      Cell: (data) => {
        const { row } = data;
        const {
          row: {
            index,
            original: { ErrorColumn },
          },
        } = data;

        return (
          <EditBox
            eanbleTextBox
            className="quantity-box"
            defaultValue={
              row?.original?.grossWeight || row?.original?.defaultGrossWeight
            }
            setNewValue={(e) => {
              setNewValue({
                values: e.target.value,
                columnName: 'grossWeight',
                index,
              });
            }}
            min="1"
            id="grossWeight"
            isError={ErrorColumn && ErrorColumn.includes('grossWeight')}
            name="grossWeight"
            decimalLimit={2}
            enableSelect
            options={[
              { label: 'Kgs', value: 'Kgs' },
              { label: 'Lbs', value: 'Lbs' },
            ]}
            onSelectChange={(e) => {
              setNewValue({
                values: e.target.value,
                columnName: 'grossWeightUnit',
                index,
              });
            }}
            defaultValueUnit={{
              label: row?.original?.grossWeightUnit || 'Kgs',
              value: row?.original?.grossWeightUnit || 'Kgs',
            }}
          />
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return (
          <span className="no-wrap">
            {t('manageordersscreen.sendbookingdetails.package')}
          </span>
        );
      },
      accessor: 'package',
      align: 'center',
      setWidth: '170px',
      Cell: (data) => {
        const { row } = data;
        const {
          row: { index },
        } = data;

        let defaultValue = row?.original?.package?.label;
        packageOptions?.forEach((obj) => {
          if (obj?.value === row?.original?.package?.value && obj?.rename) {
            if (obj?.rename?.length > 10) {
              defaultValue = `${obj?.rename?.slice(0, 11)}...`;
            } else {
              defaultValue = obj?.rename;
            }
          } else if (
            obj?.value === row?.original?.package?.value &&
            obj?.existingPackage
          ) {
            if (obj?.label?.length > 10) {
              defaultValue = `${obj?.label?.slice(0, 11)}...`;
            } else {
              defaultValue = obj?.label;
            }
          }
        });
        const [t] = useTranslation('manageorders');
        return (
          <div className="d-flex">
            <SearchSelect
              t={t}
              data={packageOptions}
              onClick={handleAddPackage}
              onChange={(e) => {
                setNewValue({
                  values: {
                    // label: e?.target?.value,
                    label:
                      e.target.innerText ||
                      e.target.textContent ||
                      e.target.label,
                    value: e?.target?.value,
                  },
                  columnName: 'package',
                  index,
                });
              }}
              label={t(
                'manageordersscreen.sendbookingdetails.packagetype.title'
              )}
              defaultValue={defaultValue}
              selectProduct={selectProduct}
              disabled={vendorPackageButton}
              handleApplyAll={(e) =>
                setApplyAllOption({
                  label: e.target.label,
                  value: e.target.value,
                })
              }
              enableBulk={true}
              enableRemove
            />
            {/* <select
              className="supplier-select-package"
              value={row?.original?.package?.value || ''}
              onChange={(e) => {
                handlePackageChange(
                  row?.original?._id,
                  {
                    label: e?.target?.value,
                    value: e?.target?.value,
                  },
                  row?.original?.itemCode
                );
                setNewValue({
                  values: {
                    label: e?.target?.value,
                    value: e?.target?.value,
                  },
                  columnName: 'package',
                  index,
                });
              }}
            >
              <option value="">Package type</option>
              {packageOptions?.map((option) => (
                <option value={option?.value}>
                  {option?.rename || option?.label}
                </option>
              ))}
            </select> */}
            {/* <Button size="icon" className="p-0 ml-10" icon={<EditIcon />} /> */}
          </div>
        );
      },
    },
  ];
  return columnData;
};

export const supplierBulkBookingColumns = ({
  setNewValue,
  packageOptions,
  handleAddPackage,
  selectProduct,
  bulk,
}) => {
  const columnData = [
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.sendbookingdetails.orderitem')}</>;
      },
      align: 'center',
      accessor: 'itemCode',
    },
    {
      // Header: () => {
      //   const [t] = useTranslation('manageorders');
      //   return <>{t('manageordersscreen.sendbookingdetails.orderitem')}</>;
      // },
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.sendbookingdetails.orderid')}</>;
      },
      align: 'center',
      accessor: 'poNumber',
    },
  ];

  if (bulk === 'bulkTab1') {
    columnData?.push(
      {
        Header: () => {
          const [t] = useTranslation('manageorders');
          return <>{t('manageordersscreen.sendbookingdetails.productname')}</>;
        },
        align: 'center',
        accessor: 'itemName',
      },
      {
        Header: () => {
          const [t] = useTranslation('manageorders');
          return <>{t('manageordersscreen.sendbookingdetails.cargoready')}</>;
        },
        align: 'center',
        accessor: 'cargoReadyDate',
        type: 'date',
        Cell: (data) => {
          const {
            cell: { row },
          } = data;
          return (
            <span>
              {row?.original?.dueDate
                ? getUserTimeZoneDateFormat(row?.original?.dueDate)
                : '--'}
            </span>
          );
        },
      },
      {
        Header: () => {
          const [t] = useTranslation('manageorders');
          return <>{t('manageordersscreen.sendbookingdetails.quantity')}</>;
        },
        align: 'center',
        accessor: 'quantity',
        Cell: (data) => {
          const {
            cell: { row },
          } = data;
          const [t] = useTranslation('manageorders');
          return (
            <div className="d-flex justify-center">
              <NumberCard
                value={row?.original?.quantity}
                status="primary"
                content={t(
                  'manageordersscreen.sendbookingdetails.tooltip.total'
                )}
              />

              <NumberCard
                value={row?.original?.cargoQty}
                status="success"
                content={t(
                  'manageordersscreen.sendbookingdetails.tooltip.processed'
                )}
              />
              <NumberCard
                value={row?.original?.bookedQty}
                status="warning"
                content={t(
                  'manageordersscreen.sendbookingdetails.tooltip.booked'
                )}
              />
              <NumberCard
                value={row?.original?.pendingQty || 0}
                content={t(
                  'manageordersscreen.sendbookingdetails.tooltip.pending'
                )}
              />
            </div>
          );
        },
      },

      {
        align: 'center',
        Header: () => {
          const [t] = useTranslation('manageorders');
          return <>{t('manageordersscreen.sendbookingdetails.status')}</>;
        },
        accessor: 'statusName',
        Cell: (data) => {
          const {
            cell: { row },
          } = data;

          return <ListingStatus statusLabel={row.original.statusName} />;
        },
      }
    );
  }

  if (bulk === 'bulkTab2') {
    columnData?.push(
      {
        Header: () => {
          const [t] = useTranslation('manageorders');
          return <>{t('manageordersscreen.sendbookingdetails.dimensions')}</>;
        },
        accessor: 'dimensions',
        align: 'center',
        Cell: (data) => {
          const { row } = data;
          return (
            <span className="no-wrap text-center d-block">
              {row?.original?.LXWXH}
            </span>
          );
        },
      },
      {
        Header: () => {
          const [t] = useTranslation('manageorders');
          return (
            <>{t('manageordersscreen.sendbookingdetails.quantitytoship')}</>
          );
        },
        align: 'center',
        accessor: 'quantityToShip',
        Cell: (data) => {
          const { row } = data;
          const {
            row: {
              index,
              // original: { errorMessage, ErrorColumn },
            },
          } = data;
          const [t] = useTranslation('manageorders');
          const calculatedQtyToShip = (
            Number(row?.original?.cargoQty) - Number(row?.original?.bookedQty)
          ).toFixed(3);
          return (
            <EditBox
              eanbleTextBox
              className="quantity-box"
              defaultValue={
                row?.original?.quantityToShip || calculatedQtyToShip || ''
              }
              setNewValue={(e) => {
                setNewValue({
                  values: e.target.value,
                  columnName: 'quantityToShip',
                  index,
                });
              }}
              min="0.001"
              max={calculatedQtyToShip}
              id="quantityToShip"
              errorMessage={`${t(
                'manageordersscreen.sendbookingdetails.addpackagedetailsbtn.errormessage.quantity'
              )} ${calculatedQtyToShip}`}
              errorLogic={calculatedQtyToShip}
              name="quantityToShip"
            />
          );
        },
      },
      {
        Header: () => {
          const [t] = useTranslation('manageorders');
          return <>{t('manageordersscreen.sendbookingdetails.grossweight')}</>;
        },
        align: 'center',
        accessor: 'grossWeight',
        Cell: (data) => {
          const { row } = data;
          const {
            row: {
              index,
              original: { ErrorColumn },
            },
          } = data;
          return (
            <EditBox
              eanbleTextBox
              className="quantity-box text-center"
              defaultValue={
                row?.original?.grossWeight || row?.original?.defaultGrossWeight
              }
              setNewValue={(e) => {
                setNewValue({
                  values: e.target.value,
                  columnName: 'grossWeight',
                  index,
                });
              }}
              min="1"
              id="grossWeight"
              isError={ErrorColumn && ErrorColumn.includes('grossWeight')}
              name="grossWeight"
              decimalLimit={2}
            />
          );
        },
      },
      {
        Header: () => {
          const [t] = useTranslation('manageorders');
          return <>{t('manageordersscreen.sendbookingdetails.package')}</>;
        },
        accessor: 'package',
        align: 'center',
        setWidth: '170px',
        Cell: (data) => {
          const { row } = data;
          const {
            row: { index },
          } = data;
          let defaultValue = row?.original?.package?.label;
          packageOptions?.forEach((obj) => {
            if (obj?.value === row?.original?.package?.value && obj?.rename) {
              if (obj?.rename?.length > 10) {
                defaultValue = `${obj?.rename?.slice(0, 11)}...`;
              } else {
                defaultValue = obj?.rename;
              }
            }
          });
          const [t] = useTranslation('manageorders');
          return (
            <div className="d-inline-flex text-center">
              <SearchSelect
                t={t}
                data={packageOptions}
                onClick={handleAddPackage}
                onChange={(e) => {
                  setNewValue({
                    values: {
                      label: e?.target?.value,
                      value: e?.target?.value,
                    },
                    columnName: 'package',
                    index,
                  });
                }}
                label={t(
                  'manageordersscreen.sendbookingdetails.packagetype.title'
                )}
                defaultValue={defaultValue}
                selectProduct={selectProduct}
              />
            </div>
          );
        },
      }
    );
  }

  return columnData;
};

export const associatedShipmentsColumn = [
  {
    Header: 'Shipment#',
    accessor: 'shipmentNo',
    Cell: (data) => {
      const {
        row,
        row: {
          values: { shipmentNo },
        },
      } = data;
      const { relation, companyId } = useParams();
      return (
        <Link
          to={`/app/${relation}/${companyId}/shipment-details/${row.original._id}`}
        >
          {shipmentNo}
        </Link>
      );
    },
  },
  {
    Header: 'Mode',
    accessor: 'mode',
    Cell: (data) => {
      const {
        cell: { row },
      } = data;
      return (
        <ShipmentMode
          shipmentMode={row.original.mode}
          bookingType={row.original.bookingType}
        />
      );
    },
  },
  // {
  //   Header: 'Delivery Date',
  //   accessor: 'ETA',
  // },
  {
    Header: 'Origin',
    accessor: 'originFacility',
  },
  {
    Header: 'Destination',
    accessor: 'destinationFacility',
  },
  {
    Header: 'Status',
    accessor: 'currentStatus',
    align: 'center',
    Cell: (data) => {
      const {
        cell: {
          row: {
            original: { currentStatus },
          },
        },
      } = data;
      return <ListingStatus statusLabel={currentStatus} />;
    },
  },
];
export const incoTermColumns = ({ setIncoToggle, incoToggle, disabled }) => {
  return [
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.incotermtable.incoterm')}</>;
      },
      accessor: 'incoterm',
      align: 'left',
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.incotermtable.select')}</>;
      },
      accessor: 'select',
      setWidth: '10vw',
      Cell: ({
        row: {
          original: { incoterm },
        },
      }) => {
        return (
          <CustomSwitch
            className="d-inline-flex"
            disabled={disabled}
            value={incoterm}
            checked={incoToggle === incoterm}
            onChange={(e) => {
              if (e.target.checked) {
                setIncoToggle(incoterm);
              } else {
                setIncoToggle('');
              }
            }}
          />
        );
      },
    },
  ];
};
export const cargoRequestColumns = (orderListRefetch) => {
  const { relation } = useParams();
  return [
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.cargorequesttab.cargorequest')}</>;
      },
      accessor: 'referenceId',
      align: 'center',
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.cargorequesttab.orders')}</>;
      },
      accessor: 'orders',
      align: 'center',
      Cell: (data) => {
        const {
          cell: {
            row: {
              original: { packages, bulkOrderIds },
            },
          },
        } = data;
        const lineItemsData = [];
        packages?.forEach((pkg) =>
          pkg?.lineItems?.forEach((item) => {
            lineItemsData?.push({
              orderId: item?.orderId,
              order: item?.poNumber,
              orderItem: item?.itemCode,
              qtyShipped: item?.qtyShipped,
              orderStatus: item?.statusName,
              cargoReady: getUserTimeZoneDateFormat(item?.dueDate),
            });
          })
        );
        const [t] = useTranslation('manageorders');
        return (
          <CountCard
            data={lineItemsData}
            label={
              bulkOrderIds?.length === 1
                ? `${bulkOrderIds?.length} ${t(
                    'manageordersscreen.cargorequesttab.order'
                  )}`
                : `${bulkOrderIds?.length || 0} ${t(
                    'manageordersscreen.cargorequesttab.orders'
                  )}`
            }
            enableDynamicTable={true}
            columns={BookListOrder2}
            disableBorder
            align="center"
          />
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.cargorequesttab.mode')}</>;
      },
      accessor: 'mode',
      align: 'center',
      Cell: (data) => {
        const {
          cell: {
            row: {
              original: { mode },
            },
          },
        } = data;
        return mode ? (
          <ShipmentMode shipmentMode={mode} align="center" />
        ) : (
          '--'
        );
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.cargorequesttab.bookingdate')}</>;
      },
      accessor: 'bookingDate',
      align: 'center',
      Cell: (data) => {
        const {
          cell: {
            row: {
              original: { bookingDate },
            },
          },
        } = data;
        return getUserTimeZoneDateFormat(bookingDate);
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.cargorequesttab.origin')}</>;
      },
      accessor: 'originFacility',
      align: 'center',
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.cargorequesttab.destination')}</>;
      },
      accessor: 'destinationFacility',
      align: 'center',
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.cargorequesttab.owner')}</>;
      },
      accessor: 'owner',
      align: 'center',
      Cell: (data) => {
        const {
          cell: {
            row: {
              original: { owner },
            },
          },
        } = data;
        return giveProfile(relation) === owner
          ? 'Self'
          : `${owner?.charAt(0)?.toUpperCase()}${owner?.slice(1)}`;
      },
    },
    {
      Header: () => {
        const [t] = useTranslation('manageorders');
        return <>{t('manageordersscreen.cargorequesttab.status')}</>;
      },
      accessor: 'currentStatus',
      align: 'center',
      Cell: (data) => {
        const {
          cell: {
            row: {
              original: { currentStatus },
            },
          },
        } = data;
        return <ListingStatus statusLabel={currentStatus} />;
      },
    },
    ...((checkPermission(giveProfile(relation), 'Booking', 'createBooking') ||
      checkPermission(
        giveProfile(relation),
        'Booking',
        'createBooking',
        'V'
      )) &&
    !checkPermission(giveProfile(relation), 'Order', 'manageScheduleDelivery')
      ? [
          {
            Header: () => {
              const [t] = useTranslation('manageorders');
              return <>{t('manageordersscreen.Bookings.actions')}</>;
            },
            accessor: 'actions',
            align: 'center',
            Cell: (data) => {
              const {
                isShowing: isViewBookingDetailsDislog,
                toggle: toggleViewDetailsModal,
              } = useDialog();
              const {
                cell: { row },
              } = data;
              const [searchParams, setSearchParams] = useSearchParams();
              const location = useLocation();
              const popover = searchParams.get('popover');
              const popId = searchParams.get('popId');
              useEffect(() => {
                const checkURLParamsAndOpenDialog = () => {
                  if (
                    popover === 'Create Booking' &&
                    !isViewBookingDetailsDislog &&
                    popId === row?.original?._id
                  ) {
                    // popover=Create+Booking&popId=170922967377830106
                    toggleViewDetailsModal();
                  }
                };
                checkURLParamsAndOpenDialog();
              }, [location.search]);
              return (
                <div className="d-flex justify-center">
                  {row?.original?.bookingAction?.addForwarder && (
                    <>
                      <IconButton
                        onClick={() => {
                          // toggleViewDetailsModal();
                          if (
                            searchParams.get('popover') !== 'Create Booking' &&
                            !location.search?.includes('Create+Booking')
                          ) {
                            searchParams.set('popover', 'Create Booking');
                            setSearchParams(searchParams);
                          }
                          if (
                            searchParams.get('popId') !== row?.original?._id &&
                            !location.search?.includes('popId')
                          ) {
                            searchParams.set('popId', row?.original?._id);
                            setSearchParams(searchParams);
                          }
                        }}
                        verient="grey"
                        disabled={
                          !checkPermission(
                            giveProfile(relation),
                            'Booking',
                            'createBooking'
                          )
                        }
                      >
                        <BoxIcon />
                      </IconButton>
                      <Dialog
                        isShowing={isViewBookingDetailsDislog}
                        hide={() => {
                          toggleViewDetailsModal();
                          searchParams.delete('popover');
                          searchParams.delete('popId');
                          setSearchParams(searchParams);
                        }}
                        placement="center"
                        // enableOutsideClick
                        enableCloseIcon
                      >
                        <BuyerBooking
                          columns={buyerBookingDetailsColumns()}
                          itemsData={row?.original}
                          toggleViewDetailsModal={toggleViewDetailsModal}
                          isBulk={true}
                          orderListRefetch={orderListRefetch}
                        />
                      </Dialog>
                    </>
                  )}
                  {!row?.original?.bookingAction?.addForwarder && (
                    <>
                      <IconButton
                        onClick={() => {
                          // toggleViewDetailsModal();
                          if (
                            searchParams.get('popover') !== 'Create Booking' &&
                            !location.search?.includes('Create+Booking')
                          ) {
                            searchParams.set('popover', 'Create Booking');
                            setSearchParams(searchParams);
                          }
                          if (
                            searchParams.get('popId') !== row?.original?._id &&
                            !location.search?.includes('popId')
                          ) {
                            searchParams.set('popId', row?.original?._id);
                            setSearchParams(searchParams);
                          }
                        }}
                        verient="grey"
                      >
                        <EditReceiptIcon />
                      </IconButton>

                      <Dialog
                        isShowing={isViewBookingDetailsDislog}
                        hide={() => {
                          toggleViewDetailsModal();
                          searchParams.delete('popover');
                          searchParams.delete('popId');
                          setSearchParams(searchParams);
                        }}
                        placement="center"
                        // enableOutsideClick
                        enableCloseIcon
                      >
                        <ViewBooking
                          id={row?.original?._id}
                          columns={buyerBookingDetailsColumns()}
                          itemsData={row?.original?.packages}
                        />
                      </Dialog>
                    </>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
  ];
};

export const costDetailsColumns = () => [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t(
        'manageordersscreen.bookingdetails.costdetails.columns.invoiceName'
      );
    },
    accessor: 'docName',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t(
        'manageordersscreen.bookingdetails.costdetails.columns.invoiceNumber'
      );
    },
    accessor: 'invoiceNumber',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return t(
        'manageordersscreen.bookingdetails.costdetails.columns.invoiceAmount'
      );
    },
    accessor: 'amount',
    align: 'left',
    Cell: (data) => {
      const {
        row: { original },
      } = data;

      const { amount, currency } = original;
      return amount != null ? `${amount.toFixed(2)} ${currency || ''}` : '--';
    },
  },
];
